<template>
  <div class="contents contents--full layout-wrapper">
    <div class="contents__wrap">
      <div class="sub-top">
        <h3>기관명: {{orgName}}의 내부통제체계 진단 관리</h3>
        <select v-model="selectedYear" class="year-dropdown" v-if="checkUserId.subRole == null">
            <option v-for="year in availableYears" :key="year" :value="year">
              {{ year }}
            </option>
        </select>
        <!-- <button class="load-button" @click="openFilePicker"  v-if="selectedYear != '2025'" >엑셀 업로드</button> -->
        <button class="load-button" @click="openFilePicker" v-if = "checkUserId.subRole == null">엑셀 업로드</button>
        <input type="file" ref="fileInput" @change="uploadExcel" accept=".xlsx, .xls" style="display: none;" />
        <!-- <button class="load-button" @click="saveExcelData">
          엑셀 데이터 저장하기
        </button> -->
        <!-- <button class="load-button" @click="loadYearData">
          전년도 데이터 불러오기
        </button>  -->
        <div class="sub-top__navi">
          <span class="icon-home navi--home"></span>
          <span>평가</span>
          <span>내부통제체계 진단 실시</span>
        </div>
      </div>

      <!-- ✅ 도메인 (레벨 1) -->
      <!-- <div 
        v-if="checkUserId.privilege != 'user'" 
        class="tree-node level-1"
        @click="showDirectEvaluations('내부 감사의 목적(Purpose of Internal Auditing)')"
      >
        <div class="node-title">
          <span class="korean-text">{{ koreanPart('내부 감사의 목적(Purpose of Internal Auditing)') }}</span>
          <span class="english-text">({{ englishPart('내부 감사의 목적(Purpose of Internal Auditing)') }})</span>
        </div>
      </div> -->

      <!-- 로딩 화면 -->
      <div v-if="isLoading" class="loading-overlay">
        <div class="spinner"></div>
        <p>{{ hasData === 'insert' ? '저장 중입니다...' : '수정 중입니다...' }}</p>
      </div>

      <!-- 트리 구조 렌더링 -->
      <div class="evaluation-tree">
        <!-- Level 1: Domain -->
        <div v-for="(domain, domainIndex) in transformedDomains" :key="domainIndex" class="tree-node level-1">
          <div class="tree-node__header" @click="toggleSubItem(domain.domainCode)">
            <div class="node-title">
              <span class="korean-text">{{ koreanPart(domain.domainName) }}</span>
              <span class="english-text">({{ englishPart(domain.domainName) }})</span>
              
            </div>
          </div>

          <!-- Level 2: Principle -->
          <div v-show="subItemsVisibility[domain.domainCode]" class="tree-node__body">
            <div v-for="(principle, principleIndex) in domain.principles" :key="principleIndex" class="tree-node level-2">
              <div class="tree-node__header" @click="toggleSubItemStandard(domain.domainCode, principle.principleCode)">
                <!-- <span class="node-title">{{ principle.principleCode }} - {{ principle.principleName }}</span> -->
                <div class="node-title">
                  <span>{{ principle.principleCode }} - </span>
                  <span class="korean-text">{{ koreanPart(principle.principleName) }}</span>
                  <span class="english-text">({{ englishPart(principle.principleName) }})</span>
                  <!-- <div class="help-icon-wrapper">
                    <div class="help-icon">?</div>
                    <span class="tooltip">{{ principle.principleContent }}</span>
                  </div> -->
                  
                </div>
              </div>

              <!-- Level 3: Standard -->
              <div v-show="subItemsVisibilityStandard[`${domain.domainCode}-${principle.principleCode}`]" class="tree-node__body">
                <div v-for="(standard, standardIndex) in principle.standards" :key="standardIndex" class="tree-node level-3">
                  <div class="tree-node__header" @click="toggleSubItemEvaluation(domain.domainCode, principle.principleCode, standard.standardCode)">
                    <!-- <span class="node-title">{{ standard.standardCode }} - {{ standard.standardName }}</span> -->
                    <div class="node-title">
                      <span>{{ standard.standardCode }} - </span>
                      <span class="korean-text">{{ koreanPart(standard.standardName) }}</span>
                      <!-- <span class="english-text">({{ englishPart(standard.standardName) }})</span> -->
                      <!-- <div class="help-icon-wrapper" v-if="standard.standardContent">
                        <div class="help-icon">?</div>  
                        <span class="tooltip-stand">{{ standard.standardContent }}</span>
                      </div> -->
                      
                    </div>
                  </div>

                  <!-- Level 4: Evaluation -->
                  <div v-show="evaluationVisibility[`${domain.domainCode}-${principle.principleCode}-${standard.standardCode}`]" class="tree-node__content">
                    <!-- <div 
                      v-for="(evaluation, evalKey) in standard.evaluations" 
                      :key="evaluation.evaluationCode" 
                      :id="`evaluation-${evaluation.evaluationCode.replace(/\./g, '-')}`"
                      class="tree-node level-4"
                    > -->
                    <div 
                      v-for="(evaluation, evalKey) in standard.evaluations" 
                      :key="evaluation.evaluationCode" 
                      class="tree-node level-4"
                      >
                      <div class="tree-node__header">
                        {{ evaluation.evaluationCode }} - {{ evaluation.evaluationName }}
                          <!-- 레드닷 표시 -->
                         
                      </div>

                      <div class="input-group"
                      :class="{ 'no-timestamp': !evaluationCurrentTime[evaluation.evaluationCode] }">
                        <div class="textarea-wrapper"
                        :class="{ 'full-width': !evaluationCurrentTime[evaluation.evaluationCode] }">
                          <label>
                            <span style="font-weight: bold; font-size: 1em;">
                              Approach:
                            </span>
                             <div class="help-icon-wrapper"
                            @click.stop="handleTooltipClick(evaluation.evaluationCode)">
                              <div class="help-icon">?</div>
                              <span class="tooltip" :class="{ 'visible': tooltipVisible[evaluation.evaluationCode] }">{{ evaluation.evaluationApproachContent }}</span>
                            </div>
                          </label>
                          <textarea
                            v-model="evaluationContent[evaluation.evaluationCode]"
                           
                          ></textarea>
                        </div>
                        <div class="timestamp-box" 
                        v-if="evaluationCurrentTime[evaluation.evaluationCode]">
                          <label>최근 저장 일시:</label>
                          <div class="timestamp">
                            <div 
                              v-if="evaluationCurrentTime[evaluation.evaluationCode]" 
                              
                              @click="resetEvaluationContent(evaluation.evaluationCode)"
                              class="timestamp-item"
                            >
                              {{ evaluationCurrentTime[evaluation.evaluationCode] }}
                            </div>
                            <div 
                              v-if="evaluationCurrent2Time[evaluation.evaluationCode]" 
                            
                              @click="updateEvaluationContent(evaluation.evaluationCode, evaluationContent2[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                              class="timestamp-item"
                            >
                              {{ evaluationCurrent2Time[evaluation.evaluationCode] }}
                            </div>
                            <div 
                              v-if="evaluationCurrent3Time[evaluation.evaluationCode]" 
                              
                              @click="updateEvaluationContent(evaluation.evaluationCode, evaluationContent3[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                              class="timestamp-item"
                            >
                              {{ evaluationCurrent3Time[evaluation.evaluationCode] }}
                            </div>
                            <div 
                              v-if="evaluationCurrent4Time[evaluation.evaluationCode]" 
                              
                              @click="updateEvaluationContent(evaluation.evaluationCode, evaluationContent4[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                              class="timestamp-item"
                            >
                              {{ evaluationCurrent4Time[evaluation.evaluationCode] }}
                            </div>
                            <div 
                              v-if="evaluationCurrent5Time[evaluation.evaluationCode]" 
                              
                              @click="updateEvaluationContent(evaluation.evaluationCode, evaluationContent5[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                              class="timestamp-item"
                            >
                              {{ evaluationCurrent5Time[evaluation.evaluationCode] }}
                            </div>
                          </div>
                        </div>
                    </div>

                    <div class="input-group">
                      <div class="textarea-wrapper full-width">
                        <label>Approach 강점:</label>
                        <textarea
                          v-model="approachStr[evaluation.evaluationCode]"
                        ></textarea>
                      </div>
                    </div>

                    <div class="input-group">
                      <div class="textarea-wrapper full-width">
                        <label>Approach 약점:</label>
                        <textarea
                          v-model="approachWeak[evaluation.evaluationCode]"
                        ></textarea>
                      </div>
                    </div>

                    <!-- ApproachA subRole가 A인 사람 -->
                    <div class="score-a-select-group" style="display: flex; gap: 12px; align-items: center; margin-top: 8px;">
                      <label>
                        <span style="font-weight: 500; margin-right: 4px;">점수 : </span>
                        <input
                          type="number"
                          :value="scoreAApproach[evaluation.evaluationCode]"
                          @input="updateScoreApproachInput($event, evaluation.evaluationCode)"
                          min="0"
                          max="25"
                          style="width: 48px; text-align:center; border: 1px solid #ccc; color:#444;"
                        />
                      </label>
                    </div>

                    

                    <!-- 개선사항 입력 -->
                    <div class="input-group"
                    :class="{ 'no-timestamp': !evaluationImpTime[evaluation.evaluationCode] }"
                    >
                      <div class="textarea-wrapper"
                      :class="{ 'full-width': !evaluationImpTime[evaluation.evaluationCode] }"
                      >
                        <label>
                          <span style="font-weight: bold; font-size: 1em;">
                            Deployment:
                          </span>
                            <div class="help-icon-wrapper"
                            @click.stop="handleTooltipClick(evaluation.evaluationCode)">
                              <div class="help-icon">?</div>
                              <span class="tooltip" :class="{ 'visible': tooltipVisible[evaluation.evaluationCode] }">{{ evaluation.evaluationDeploymentContent }}</span>
                            </div>
                        </label>
                        <textarea
                          v-model="evaluationImprovements[evaluation.evaluationCode]"
                         
                        ></textarea>
                      </div>
                      <div class="timestamp-box" v-if="evaluationImpTime[evaluation.evaluationCode]">
                        <label>최근 저장 일시:</label>
                        <div class="timestamp">
                          <div
                            v-if="evaluationImpTime[evaluation.evaluationCode]"
                            @click="resetEvaluationImprovements(evaluation.evaluationCode)"
                           
                            class="timestamp-item"
                          >
                            {{ evaluationImpTime[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationImp2Time[evaluation.evaluationCode]"
                           
                            @click="updateEvaluationImprovements(evaluation.evaluationCode, evaluationImprovements2[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationImp2Time[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationImp3Time[evaluation.evaluationCode]"
                            
                            @click="updateEvaluationImprovements(evaluation.evaluationCode, evaluationImprovements3[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationImp3Time[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationImp4Time[evaluation.evaluationCode]"
                           
                            @click="updateEvaluationImprovements(evaluation.evaluationCode, evaluationImprovements4[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationImp4Time[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationImp5Time[evaluation.evaluationCode]"
                            
                            @click="updateEvaluationImprovements(evaluation.evaluationCode, evaluationImprovements5[evaluation.evaluationCode] ,iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationImp5Time[evaluation.evaluationCode] }}
                          </div>
                        </div>
                        
                      </div>
                    </div> 


                    <div class="input-group">
                      <div class="textarea-wrapper full-width">
                        <label>Deployment 강점:</label>
                        <textarea
                          v-model="deploymentStr[evaluation.evaluationCode]"
                        ></textarea>
                      </div>
                    </div>

                    <div class="input-group">
                      <div class="textarea-wrapper full-width">
                        <label>Deployment 약점:</label>
                        <textarea
                          v-model="deploymentWeak[evaluation.evaluationCode]"
                        ></textarea>
                      </div>
                    </div>

                    <!-- DeploymentA subRole가 A인 사람 -->
                    <div class="score-a-select-group" style="display: flex; gap: 12px; align-items: center; margin-top: 8px;">
                      <label>
                        <span style="font-weight: 500; margin-right: 4px;">점수 : </span>
                        <input
                          type="number"
                          :value="scoreADeployment[evaluation.evaluationCode]"
                          @input="updateScoreDeploymentInput($event, evaluation.evaluationCode)"
                          min="0"
                          max="25"
                          style="width: 48px; text-align:center; border: 1px solid #ccc; color:#444;"
                        />
                      </label>
                    </div>

                    <!-- 모니터링 입력 -->
                     <div class="input-group"
                    :class="{ 'no-timestamp': !evaluationMonitoringTime[evaluation.evaluationCode] }"
                    >
                      <div class="textarea-wrapper"
                      :class="{ 'full-width': !evaluationMonitoringTime[evaluation.evaluationCode] }"
                      >
                      <label>
                        <span style="font-weight: bold; font-size: 1em;">
                          Monitoring Process:
                        </span>
                        <div class="help-icon-wrapper"
                        @click.stop="handleTooltipClick(evaluation.evaluationCode)">
                          <div class="help-icon">?</div>
                          <span class="tooltip" :class="{ 'visible': tooltipVisible[evaluation.evaluationCode] }">{{ evaluation.evaluationMonitoringContent }}</span>
                      </div>
                      </label>
                        <textarea
                          v-model="evaluationMonitoring[evaluation.evaluationCode]"
                        ></textarea>
                      </div>
                      <div class="timestamp-box" v-if="evaluationMonitoringTime[evaluation.evaluationCode]">
                        <label>최근 저장 일시:</label>
                        <div class="timestamp">
                          <div
                            v-if="evaluationMonitoringTime[evaluation.evaluationCode]"
                            @click="resetEvaluationMonitoring(evaluation.evaluationCode)"
                            :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                            class="timestamp-item"
                          >
                            {{ evaluationMonitoringTime[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationMonitoring2Time[evaluation.evaluationCode]"
                            :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                            @click="updateEvaluationMonitoring(evaluation.evaluationCode, evaluationMonitoring2[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationMonitoring2Time[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationMonitoring3Time[evaluation.evaluationCode]"
                            :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                            @click="updateEvaluationMonitoring(evaluation.evaluationCode, evaluationMonitoring3[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationMonitoring3Time[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationMonitoring4Time[evaluation.evaluationCode]"
                            :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                            @click="updateEvaluationMonitoring(evaluation.evaluationCode, evaluationMonitoring4[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationMonitoring4Time[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationMonitoring5Time[evaluation.evaluationCode]"
                            :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                            @click="updateEvaluationMonitoring(evaluation.evaluationCode, evaluationMonitoring5[evaluation.evaluationCode] ,iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationMonitoring5Time[evaluation.evaluationCode] }}
                          </div>
                        </div>
                        
                      </div>
                    </div> 

                    <div class="input-group">
                      <div class="textarea-wrapper full-width">
                        <label>Monitoring 강점:</label>
                        <textarea
                          v-model="monitotingStr[evaluation.evaluationCode]"
                        ></textarea>
                      </div>
                    </div>

                    <div class="input-group">
                      <div class="textarea-wrapper full-width">
                        <label>Monitoring 약점:</label>
                        <textarea
                          v-model="monitotingWeak[evaluation.evaluationCode]"
                        ></textarea>
                      </div>
                    </div>

                    <!-- MonitoringA subRole가 A인 사람 -->
                    <div class="score-a-select-group" style="display: flex; gap: 12px; align-items: center; margin-top: 8px;">
                      <label>
                        <span style="font-weight: 500; margin-right: 4px;">점수 : </span>
                        <input
                          type="number"
                          :value="scoreAMonitoring[evaluation.evaluationCode]"
                          @input="updateScoreMonitoringInput($event, evaluation.evaluationCode)"
                          min="0"
                          max="25"
                          style="width: 48px; text-align:center; border: 1px solid #ccc; color:#444;"
                        />
                      </label>
                    </div>



                    <div class="input-group"
                      :class="{ 'no-timestamp': !evaluationActionTime[evaluation.evaluationCode] }"
                      >
                        <div class="textarea-wrapper"
                        :class="{ 'full-width': !evaluationActionTime[evaluation.evaluationCode] }"
                        >
                          <label>
                            <span style="font-weight: bold; font-size: 1em;">
                              Action:
                            </span>
                               <div class="help-icon-wrapper"
                              @click.stop="handleTooltipClick(evaluation.evaluationCode)">
                              <div class="help-icon">?</div>
                              <span class="tooltip" :class="{ 'visible': tooltipVisible[evaluation.evaluationCode] }">{{ evaluation.evaluationActionContent }}</span>
                              </div>
                          </label>
                          <textarea
                            v-model="evaluationAction[evaluation.evaluationCode]"
                          ></textarea>
                        </div>
                        <div class="timestamp-box" v-if="evaluationActionTime[evaluation.evaluationCode]">
                          <label>최근 저장 일시:</label>
                          <div class="timestamp">
                            <div
                              v-if="evaluationActionTime[evaluation.evaluationCode]"
                              @click="resetEvaluationAction(evaluation.evaluationCode)"
                              :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                              class="timestamp-item"
                            >
                              {{ evaluationActionTime[evaluation.evaluationCode] }}
                            </div>
                            <div
                              v-if="evaluationAction2Time[evaluation.evaluationCode]"
                              :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                              @click="updateEvaluationAction(evaluation.evaluationCode, evaluationAction2[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                              class="timestamp-item"
                            >
                              {{ evaluationAction2Time[evaluation.evaluationCode] }}
                            </div>
                            <div
                              v-if="evaluationAction3Time[evaluation.evaluationCode]"
                              :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                              @click="updateEvaluationAction(evaluation.evaluationCode, evaluationAction3[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                              class="timestamp-item"
                            >
                              {{ evaluationAction3Time[evaluation.evaluationCode] }}
                            </div>
                            <div
                              v-if="evaluationAction4Time[evaluation.evaluationCode]"
                              :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                              @click="updateEvaluationAction(evaluation.evaluationCode, evaluationAction4[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                              class="timestamp-item"
                            >
                              {{ evaluationAction4Time[evaluation.evaluationCode] }}
                            </div>
                            <div
                              v-if="evaluationAction5Time[evaluation.evaluationCode]"
                              :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                              @click="updateEvaluationAction(evaluation.evaluationCode, evaluationAction5[evaluation.evaluationCode] ,iqcCompletedYn[evaluation.evaluationCode])"
                              class="timestamp-item"
                            >
                              {{ evaluationAction5Time[evaluation.evaluationCode] }}
                            </div>
                          </div>
                          
                        </div>
                     </div> 

                    <div class="input-group">
                      <div class="textarea-wrapper full-width">
                        <label>Action 강점:</label>
                        <textarea
                          v-model="actionStr[evaluation.evaluationCode]"
                        ></textarea>
                      </div>
                    </div>

                    <div class="input-group">
                      <div class="textarea-wrapper full-width">
                        <label>Action 약점:</label>
                        <textarea
                          v-model="actionWeak[evaluation.evaluationCode]"
                        ></textarea>
                      </div>
                    </div>

                    <!-- ActionA subRole가 A인 사람 -->
                    <div class="score-a-select-group" style="display: flex; gap: 12px; align-items: center; margin-top: 8px;">
                      <label>
                        <span style="font-weight: 500; margin-right: 4px;">점수 : </span>
                        <input
                          type="number"
                          :value="scoreAAction[evaluation.evaluationCode]"
                          @input="updateScoreActionInput($event, evaluation.evaluationCode)"
                          min="0"
                          max="25"
                          style="width: 48px; text-align:center; border: 1px solid #ccc; color:#444;"
                        />
                      </label>
                    </div>


                     <!-- 검토 요청사항 -->
                    <div class="input-group"
                    :class="{ 'no-timestamp': !evaluationCmtTime[evaluation.evaluationCode] }">
                      <div class="textarea-wrapper"
                      :class="{ 'full-width': !evaluationCmtTime[evaluation.evaluationCode] }"
                      >
                        <label>검토 요청사항:</label>
                        <textarea
                          v-model="evaluationComment[evaluation.evaluationCode]"
                         
                        ></textarea>
                      </div>
                      <div class="timestamp-box" v-if="evaluationCmtTime[evaluation.evaluationCode]" >
                        <label>최근 저장 일시:</label>
                        <div class="timestamp" :readonly="iqcCompletedYn[evaluation.evaluationCode] =='Y'" >
                          <div
                            v-if="evaluationCmtTime[evaluation.evaluationCode]"
                           
                            @click="resetEvaluationComment(evaluation.evaluationCode,iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationCmtTime[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationCmtTime2[evaluation.evaluationCode]"
                           
                            @click="updateEvaluationComment(evaluation.evaluationCode, evaluationComment2[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationCmtTime2[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationCmtTime3[evaluation.evaluationCode]"
                           
                            @click="updateEvaluationComment(evaluation.evaluationCode, evaluationComment3[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationCmtTime3[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationCmtTime4[evaluation.evaluationCode]"
                           
                            @click="updateEvaluationComment(evaluation.evaluationCode, evaluationComment4[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationCmtTime4[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationCmtTime5[evaluation.evaluationCode]"
                           
                            @click="updateEvaluationComment(evaluation.evaluationCode, evaluationComment5[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationCmtTime5[evaluation.evaluationCode] }}
                          </div>
                        </div>
                        <div class="return-button-wrapper">
                        </div>
                      </div>
                    </div>
                    

                    <div class="input-group">
                      <div class="textarea-wrapper full-width">
                        <label>개선 권고사항:</label>
                        <textarea
                          v-model="eqcComment[evaluation.evaluationCode]"
                        ></textarea>

                        <div class="return-button-wrapper">
                          <button
                            class="return-button"
                             @click="markFeedbackAsComplete(evaluation.evaluationCode)"
                             >
                            개선권고사항 없음
                          </button>
                        </div>

                      </div>
                    </div>
                      

                    <!-- 점수 슬라이더 -->
                    <!-- <div>
                      <label>점수:</label>
                      <input
                        type="number"
                        min="0"
                        max="100"
                        :value="evaluationScore[evaluation.evaluationCode]"
                        @input="updateScoreInput(evaluation.evaluationCode, $event)"
                        :disabled="iqcCompletedYn[evaluation.evaluationCode] == 'Y'"
                        class="score-input"
                        style="width:100px;"
                      />
                      <span>점</span>
                    </div> -->


                     <div class="score-a-select-group" style="display: flex; gap: 12px; align-items: center; margin-top: 8px;">
                      <!-- Read-only ScoreA -->
                      <label>
                        <span style="font-weight: 500; margin-right: 4px;">총 점수 : </span>
                        <input
                            type="text"
                            v-model="evaluationScore[evaluation.evaluationCode]"
                            disabled
                            style="width: 48px; text-align:center; border: 1px solid #ccc; color:#444;"
                          />
                      </label>
                    </div>

                    <!-- 파일 업로드 -->
                    <div class="input-group">
                      <label>첨부파일:</label>
                      <input 
                        type="file"
                        @change="handleFileUpload(evaluation.evaluationCode, $event)" 
                        multiple
                        :disabled="iqcCompletedYn[evaluation.evaluationCode] == 'Y'"
                      />
                    </div>

                        <!-- 파일 목록 -->
                      <ul class="attach-list">
                        <li v-for="(file, fileIndex) in evaluationFiles[evaluation.evaluationCode] || []" :key="fileIndex">
                          {{ file.name }}
                          <button @click="removeFile(evaluation.evaluationCode, fileIndex)"
                          v-if="iqcCompletedYn[evaluation.evaluationCode] != 'Y' && checkUserId.subRole == null">❌</button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 저장 버튼 -->
      <div class="save-button-container" v-if="selectedYear == '2025'">

        <button @click="saveData(hasData)">
          {{ hasData === 'insert' ? '저장' : '저장' }}
        </button>

        <button @click="validateBeforeFinalSave" v-if="hasData != 'insert' && checkUserId.subRole == null">
          검토완료
        </button>

        <button class="Excel-button" @click="downloadExcel" v-if="checkUserId.subRole == null">엑셀 다운로드</button>

        <button class="download-button" @click="downloadAllFilesDirectly">첨부파일 일괄 다운로드</button>
      </div>

    </div>
  </div>
</template>


<script setup>
import { reactive, ref, computed, onMounted,onUnmounted,toRaw,nextTick } from "vue";
import { useStore } from "vuex";
import { useRouter,useRoute } from 'vue-router'
import { insertGias ,updateGiasFile,getIQCApproveList,updateFeedbackForIQA,
  updateFeedbackCompletionStatus,
  finalizeEvaluation,
  updateGiasByEQC,
  insertEqcComment,
  sendIQCMail,checkSavedGIAS
 } from '@/api/giasinput'
// Vuex 데이터 및 API 호출
import axios from 'axios';
import * as XLSX from "xlsx";
const route = useRoute()
const store = useStore();
const checkUserId = computed(() => store.state.temp.userInfo);

const isLoading = ref(false) // 로딩 상태 변수 추가

// 연도 콤보박스 선택된 값
const selectedYear = ref('2025');

// 연도 목록 (현재 연도부터 과거 5년까지)
const availableYears = ref(
      Array.from({ length: 6 }, (_, i) => new Date().getFullYear() - i)
    );


// Vuex로부터 데이터 가져오기
const domainList = computed(() => store.state.grid.domainData); // 승인된 내부통제체계 진단 조회
// 저장된 내부통제체계 진단 조회
const orgEvlList = computed(() => {
	return store.state.grid.evlOrgData
})

const updateScoreApproachInput = (event,evaluationCode) => {
  const val = Math.max(0, Math.min(25, Number(event.target.value) || 0));
  scoreAApproach[evaluationCode] = val;
  event.target.value = val; // 입력창 값도 즉시 보정
};

const updateScoreDeploymentInput = (event,evaluationCode) => {
  const val = Math.max(0, Math.min(25, Number(event.target.value) || 0));
  scoreADeployment[evaluationCode] = val;
  event.target.value = val; // 입력창 값도 즉시 보정
};

const updateScoreMonitoringInput = (event,evaluationCode) => {
  const val = Math.max(0, Math.min(25, Number(event.target.value) || 0));
  scoreAMonitoring[evaluationCode] = val;
  event.target.value = val; // 입력창 값도 즉시 보정
};

const updateScoreActionInput = (event,evaluationCode) => {
  const val = Math.max(0, Math.min(25, Number(event.target.value) || 0));
  scoreAAction[evaluationCode] = val;
  event.target.value = val; // 입력창 값도 즉시 보정
};


// 수정시간을 클릭하면 그 시간에 수정한 내용이 매핑됨됨
const updateEvaluationContent = (evaluationCode, content,iqcCompletedYn) => {
  // 클릭한 시간에 매핑된 내용을 v-model에 업데이트

  if(iqcCompletedYn == 'Y'){
    evaluationContent[evaluationCode] = initialEvaluationContent[code]
  }else{
    evaluationContent[evaluationCode] = content;
  }
};
// 현황 돌아가기 버튼
const resetEvaluationContent = (code) => {
  evaluationContent[code] = initialEvaluationContent[code] || ""; // 초기 데이터로 되돌림
};

// 개선사항 업데이트 로직
const updateEvaluationImprovements = (evaluationCode, content,iqcCompletedYn) => {
  if(iqcCompletedYn == "Y"){
    evaluationImprovements[evaluationCode] = initialEvaluationImprovements[evaluationCode];
  }else{
    evaluationImprovements[evaluationCode] = content;
  }
};
// 개선사항 초기화 로직
const resetEvaluationImprovements = (evaluationCode) => {
  evaluationImprovements[evaluationCode] = initialEvaluationImprovements[evaluationCode] || "";
};


// 검토 요청사항 업데이트 로직
const updateEvaluationComment = (evaluationCode, content,iqcCompletedYn) => {
  if(iqcCompletedYn == "Y"){
    evaluationComment[evaluationCode] = initialEvaluationComment[evaluationCode] || "";
  }else{
    evaluationComment[evaluationCode] = content;
  }
};

// 검토 요청사항 초기화 로직
const resetEvaluationComment = (evaluationCode) => {
  evaluationComment[evaluationCode] = initialEvaluationComment[evaluationCode] || "";
};

// 개선사항 업데이트 로직
const updateEvaluationMonitoring = (evaluationCode, content,iqcCompletedYn) => {
  if(iqcCompletedYn == "Y"){
    evaluationMonitoring[evaluationCode] = initialEvaluationMonitoring[evaluationCode];
  }else{
    evaluationMonitoring[evaluationCode] = content;
  }
};

const updateEvaluationAction = (evaluationCode, content,iqcCompletedYn) => {
  if(iqcCompletedYn == "Y"){
    evaluationAction[evaluationCode] = initialEvaluationAction[evaluationCode];
  }else{
    evaluationAction[evaluationCode] = content;
  }
};


// 개선사항 초기화 로직
const resetEvaluationAction = (evaluationCode) => {
  evaluationAction[evaluationCode] = initialEvaluationAction[evaluationCode] || "";
};
// 개선사항 초기화 로직
const resetEvaluationMonitoring = (evaluationCode) => {
  evaluationMonitoring[evaluationCode] = initialEvaluationMonitoring[evaluationCode] || "";
};


// 초기 데이터 상태 저장
let initialEvaluationContent = {};
let initialEvaluationImprovements = {};
let initialEvaluationScore = {};
let initialEvaluationComment = {};
let initialEvaluationEQCComment = {};
let initialEvaluationMonitoring = {};
let initialEvaluationAction = {};

const hasData = ref(false);
const isSticky = ref(false);

// 점수에 따른 슬라이더 색상 반환
const getSliderColor = (score) => {
  if (score == 0) return '#808080'; // 회색
  if (score == 1) return '#f22805'; // 완전 빨간색
  if (score == 2) return '#f57a64'; // 약한 빨간색
  if (score == 3) return '#FFD700'; // 노란색
  if (score == 4) return '#00FF00'; // 연한 초록색색
  if (score == 5) return '#009000'; // 노란색
  return '#FFFFFF'; // 초록색
};

// 한글 부분 추출 (괄호 밖 텍스트)
const koreanPart = (text) => {
  if (!text) return '';
  // 영어 괄호 내용을 제거: 괄호 안이 영어로만 되어 있는 부분 삭제
  return text.replace(/\((?:[A-Za-z][^()]*)\)/g, '').trim();
};

// 영어 부분 추출 (괄호 안 텍스트)
const englishPart = (text) => {
  if (!text) return '';
  // 괄호 안의 영어만 추출
  const matches = text.match(/\(([A-Za-z][^()]*)\)/g);
  if (!matches || matches.length === 0) return '';
  // 마지막 괄호 기준 (원하면 처음 걸로도 가능)
  return matches[matches.length - 1].replace(/[()]/g, '').trim();
};

const fileInput = ref(null);
const rowCount = ref(null); // F열 데이터 개수 저장

// 📌 파일 선택 창 열기
const openFilePicker = () => {
  fileInput.value.click();
};

const evaluationCodes_1 = [
  "1.1.1.1",
  "1.1.2.1",
  "1.1.3.1",
  "1.1.4.1",
  "1.1.5.1",
  "1.1.6.1",
  "1.1.6.2",
  "1.1.7.1",
  "1.1.7.2",
  "1.2.1.1",
  "1.2.2.1",
  "1.3.1.1",
  "1.3.2.1",
  "1.3.2.2",
  "1.3.3.1",
  "1.3.4.1",
  "1.3.4.2",
  "1.3.5.1",
  "1.3.6.1",
  "1.3.7.1",
  "1.3.7.2",
  "1.3.8.1",
  "1.3.9.1",
  "1.4.1.1",
  "1.4.2.1",
  "1.4.3.1",
  "1.4.4.1",
  "1.4.5.1",
  "1.5.1.1",
  "1.5.1.2",
  "1.5.2.1",
  "1.5.3.1",
  "1.5.4.1",
  "1.5.5.1",
  "1.5.6.1",
  "1.6.1.1",
  "1.6.1.2",
  "1.6.2.1",
  "1.6.3.1",
  "1.6.4.1",
  "1.7.1.1",
  "1.7.2.1",
  "1.7.2.2",
  "1.7.3.1",
  "1.7.4.1",
  "1.7.5.1",
  "1.7.6.1",
  "2.1.1.3",
  "2.1.1.1",
  "2.1.1.2",
  "2.1.1.4",
  "2.1.1.5",
  "2.1.2.1",
  "2.1.3.1",
  "2.1.3.2",
  "2.1.4.1",
  "2.1.4.2",
  "2.2.1.1",
  "2.2.2.1",
  "2.2.3.1",
  "2.2.3.2",
  "2.2.3.3",
  "2.2.4.1",
  "2.2.5.1",
  "2.2.6.1",
  "2.2.6.2",
  "2.2.7.1",
  "2.3.1.1",
  "2.3.2.1",
  "2.3.3.1",
  "2.3.4.1",
  "2.3.4.2",
  "2.4.1.1",
  "2.4.2.1",
  "3.1.1.1",
  "3.1.1.2",
  "3.2.1.2",
  "3.2.1.1",
  "3.2.2.1",
  "3.2.3.1",
  "4.1.1.1",
  "4.1.1.2",
  "4.1.2.1",
  "4.1.2.2",
  "4.1.2.3",
  "4.1.3.1",
  "4.1.3.2",
  "4.1.4.1",
  "4.1.4.2",
  "4.2.1.2",
  "4.2.1.1",
  "4.2.2.1",
  "4.2.2.2",
  "4.2.3.1",
  "4.2.3.2",
  "4.2.4.1",
  "4.2.5.1",
  "4.2.5.2",
  "4.2.5.3",
  "4.2.6.1",
  "4.2.6.2",
  "4.2.7.1",
  "4.2.7.2",
  "4.2.7.3",
  "5.1.1.1",
  "5.1.1.2",
  "5.1.2.1",
  "5.1.2.2",
  "5.1.3.1",
  "5.1.4.1",
  "5.1.5.1",
  "5.1.6.1",
  "5.1.6.2",
  "5.1.7.1",
  "5.1.7.2",
  "5.1.7.3",
  "5.1.7.4",
  "5.2.1.1",
  "5.2.2.1",
  "5.2.2.2",
  "5.2.3.1",
  "5.3.1.1",
  "5.3.1.2",
  "5.3.2.1",
  "5.3.2.2",
  "5.3.3.1",
  "5.3.3.2",
  "5.3.4.1",
  "5.3.4.2",
  "5.4.1.1",
  "5.4.2.1",
  "5.4.2.2",
  "5.4.3.1"
];

const tooltipVisible = reactive({});

const handleTooltipClick = (code) => {
  // 이미 열려있는 경우(내가 다시 클릭) → 토글
  if (tooltipVisible[code]) {
    tooltipVisible[code] = false;
  } else {
    // 다른 모든 툴팁 닫기
    Object.keys(tooltipVisible).forEach((key) => {
      tooltipVisible[key] = false;
    });
    tooltipVisible[code] = true;
  }
};


// const uploadExcel = (event) => {
//   const file = event.target.files[0];
//   if (!file) return;

//   const targetSheetName = "내부통제체계 진단 결과"; // 🔥 원하는 시트 이름으로 변경

//   const reader = new FileReader();
//   reader.onload = (e) => {
//     const data = new Uint8Array(e.target.result);
//     const workbook = XLSX.read(data, { type: "array" });

//     // 🔥 특정 시트 이름이 존재하는지 확인
//     if (!workbook.SheetNames.includes(targetSheetName)) {
//       alert(`"${targetSheetName}" 시트를 찾을 수 없습니다.`);
//       return;
//     }

//     const worksheet = workbook.Sheets[targetSheetName];

//     const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
//     console.log(`"${targetSheetName}" 시트의 데이터:`, jsonData);

//     const gColumnData = [];
//     const hColumnData = [];
//     const iColumnData = [];
//     const jColumnData = [];

//     // F열과 G열 데이터를 함께 가져오기
//     jsonData.forEach(row => {
//       const gValue = row[6]; // G열 데이터
//       const hValue = row[7]; // H열 데이터
//       const iValue = row[8]; // i열 데이터
//       const jValue = row[9]; // j열 데이터

//       // F열 데이터가 유효한 경우만 추가 (G열도 같은 인덱스에 추가)
//       if (gValue !== undefined && gValue !== null && gValue !== "" && gValue !== " ") {
//         gColumnData.push(gValue);
//         hColumnData.push(hValue || ""); // H열 값이 없을 경우 빈 문자열
//         iColumnData.push(iValue || ""); // i열 값이 없을 경우 빈 문자열
//         jColumnData.push(jValue || ""); // j열 값이 없을 경우 빈 문자열
//       }
//     });

//     // F열과 G열 데이터를 evaluationContent와 evaluationDate에 매핑
//     evaluationCodes_1.forEach((code, index) => {
//       evaluationContent[code] = gColumnData[index] || ""; // G열 값 저장
//       evaluationImprovements[code] = hColumnData[index] || ""; // H열 값 저장
//       evaluationMonitoring[code] = iColumnData[index] || ""; // i열 값 저장
//       evaluationAction[code] = jColumnData[index] || ""; // j열 값 저장
//     });

//   };
//   reader.readAsArrayBuffer(file);
// };

const uploadExcel = (event) => {
  const file = event.target.files[0];
  if (!file) return;

  const targetSheetName = "내부통제체계 진단 결과";
  const reader = new FileReader();

  reader.onload = (e) => {
    const data = new Uint8Array(e.target.result);
    const workbook = XLSX.read(data, { type: "array" });

    if (!workbook.SheetNames.includes(targetSheetName)) {
      alert(`"${targetSheetName}" 시트를 찾을 수 없습니다.`);
      return;
    }

    const ws = workbook.Sheets[targetSheetName];

    // ✅ 각 칼럼을 'A','B' 키로 읽고, 빈 칸은 항상 ''로
    const rows = XLSX.utils.sheet_to_json(ws, {
      header: "A",
      raw: false,     // 숫자도 문자열로 받아 코드를 안전하게 처리
      defval: ""      // 빈 셀도 ''로 채워서 인덱스 깨짐 방지
    });

    // 원하는 열 정의 (필요시 바꾸세요)
    const COL_CODE = "E"; // 평가코드 열

    const COL_G    = "G"; // 내용
    const COL_H    = "H"; // 개선
    const COL_I    = "I"; // 모니터링
    const COL_J    = "J"; // 조치

    const COL_K    = "K"; // 내용
    const COL_L    = "L"; // 개선
    const COL_M    = "M"; // 모니터링
    const COL_N    = "N"; // 조치

    const COL_O    = "O"; // 내용
    const COL_P    = "P"; // 개선
    const COL_Q    = "Q"; // 모니터링
    const COL_R    = "R"; // 조치

    const COL_S    = "S"; // 내용
    const COL_T    = "T"; // 개선
    const COL_U    = "U"; // 모니터링
    const COL_V    = "V"; // 조치


    const COL_X    = "X"; // 개선권고사항
    // 허용되는 코드 목록(업로드 대상)

    let lastCode = ""; // 병합 셀 대비: 직전 코드값 유지

    for (const row of rows) {
      // 코드 읽기(+공백 정리)
      let code = String(row[COL_CODE] || "").trim();
      if (!code) code = lastCode; else lastCode = code; // 병합된 경우 아래 행은 코드가 비어있을 수 있음

      // 텍스트 값들 정리(공백, NBSP 등 제거)
      const norm = (v) => String(v ?? "").replace(/\u00A0/g, " ").trim();

      const g = row[COL_G]; // 어프로치 내용
      const h = norm(row[COL_H]); // 어프로치 점수
      const i = norm(row[COL_I]); // 어프로치 강점
      const j = norm(row[COL_J]); // 어프로치 약점

      const k = norm(row[COL_K]); // Deployment 내용
      const l = norm(row[COL_L]); // Deployment 점수
      const m = norm(row[COL_M]); // Deployment 강점
      const n = norm(row[COL_N]); // Deployment 약점

      const o = norm(row[COL_O]); // Monitoring 내용
      const p = norm(row[COL_P]); // Monitoring 점수
      const q = norm(row[COL_Q]); // Monitoring 강점
      const r = norm(row[COL_R]); // Monitoring 약점

      const s = norm(row[COL_S]); // Action 내용
      const t = norm(row[COL_T]); // Action 점수
      const u = norm(row[COL_U]); // Action 강점
      const v = norm(row[COL_V]); // Action 약점

      const x = norm(row[COL_X]); // 개선권고사항

      // 전부 빈칸이면 스킵(원하면 주석 처리)
      if (!g && !h && !i && !j) continue;

      // ✅ 코드 키로 직접 매핑
      evaluationContent[code] = g;
      scoreAApproach[code] = h;
      approachStr[code] = i;
      approachWeak[code] = j

      evaluationImprovements[code]  = k;
      scoreADeployment[code] = l;
      deploymentStr[code] = m;
      deploymentWeak[code] = n;

      evaluationMonitoring[code]    = o;
      scoreAMonitoring[code] = p;
      monitotingStr[code] = q;
      monitotingWeak[code]  = r;

      evaluationAction[code] = s;
      scoreAAction[code] = t;
      actionStr[code] = u;
      actionWeak[code] = v;

      eqcComment[code] = x;
    }

    console.log("업로드 매핑 완료", {
      content: evaluationContent,
      improvements: evaluationImprovements,
      monitoring: evaluationMonitoring,
      action: evaluationAction
    });
  };

  reader.readAsArrayBuffer(file);
};

const updateSlider = (evaluationCode, event) => {
  // 슬라이더 값이 숫자로 변환되도록 보장
  evaluationScore[evaluationCode] = Number(event.target.value);
};

const handleScroll = () => {
    const stickyThreshold = 150; // 버튼이 고정될 스크롤 위치 (px)
    isSticky.value = window.scrollY > stickyThreshold;
};



// 평가 데이터 하드코딩
const directEvaluations = ref([
  {
    evaluationCode: 'A.1',
    evaluationName: '감사규정 혹은 감사매뉴얼에 내부감사의 성격 및 기능에 대한 내용을 명시',
    content_A: '',
    improvement_A: '',
    comment_A: '',
    score_A: 0,
    completedYn_A : '',
    eqcComment_A : '',
    iqcCompletedYn : '',
    files: []
  },
  {
    evaluationCode: 'A.2',
    evaluationName: '내부감사의 목적, 권한 및 책임은 내부감사의 비전·전략 및 국제내부감사표준과 의미적으로 부합되게 명시',
    content_A: '',
    improvement_A: '',
    comment_A: '',
    score_A: 0,
    completedYn_A : '',
    eqcComment_A : '',
    iqcCompletedYn : '',
    files: []
  }
]);

// 도메인 클릭 이벤트
const selectedDomain = ref(null); // 선택된 도메인

const showDirectEvaluations = (domainName) => {
  if (selectedDomain.value === domainName) {
    // 이미 선택된 도메인이라면 접기
    selectedDomain.value = null;
  } else {
    // 다른 도메인을 클릭하면 펼치기
    selectedDomain.value = domainName;
  }
};

// 파일 업로드 핸들러
const handleFileUpload_A = (evaluationCode, event) => {
  const files = event.target.files;
  if (files && files.length > 0) {
    Array.from(files).forEach((file) => {
      const evalItem = directEvaluations.value.find((item) => item.evaluationCode === evaluationCode);
      if (evalItem) {
        evalItem.files.push(file);
      }
    });
  }
};


// 파일 제거 핸들러
const removeFile_A = (evaluationCode, fileIndex) => {
  const evalItem = directEvaluations.value.find((item) => item.evaluationCode === evaluationCode);
  if (evalItem) {
    // 기존 파일 삭제
    if (evalItem.files[fileIndex]) {
      evalItem.files.splice(fileIndex, 1);
    }

    // 기존 파일 경로 유지
    if (existingFiles[evaluationCode]) {
      existingFiles[evaluationCode].splice(fileIndex, 1);
    }

    console.log(`A 도메인 ${evaluationCode} 파일 삭제됨. 남은 파일:`, evalItem.files);
  }
};

const markFeedbackAsComplete = async (evaluationCode) => {
  eqcComment[evaluationCode] = '개선권고사항 없음'
};

const handleFileUpload = (evaluationCode, event) => {
  const files = Array.from(event.target.files); // 다중 파일 배열화

  if (!evaluationFiles[evaluationCode]) evaluationFiles[evaluationCode] = [];
  if (!newFiles[evaluationCode]) newFiles[evaluationCode] = [];

  files.forEach((file) => {
    evaluationFiles[evaluationCode].push(file);
    newFiles[evaluationCode].push(file); // 새로 추가된 파일
  });
};

const removeFile = (evaluationCode, fileIndex) => {
  const removedFile = evaluationFiles[evaluationCode].splice(fileIndex, 1)[0];

  // 삭제된 파일을 `deletedFiles`로 이동
  if (existingFiles[evaluationCode]?.some((file) => file.name === removedFile.name)) {
    if (!deletedFiles[evaluationCode]) deletedFiles[evaluationCode] = [];
    deletedFiles[evaluationCode].push(removedFile);
    // 기존 파일 배열에서 삭제
    existingFiles[evaluationCode] = existingFiles[evaluationCode].filter(
      (file) => file.name !== removedFile.name
    );
  } else {
    // 새로 추가된 파일 중 삭제
    newFiles[evaluationCode] = newFiles[evaluationCode].filter(
      (file) => file.name !== removedFile.name
    );
  }
};

//레드닷 전파 로직
const propagateRedDot = (domains) => {
  domains.forEach((domain) => {
    let domainHasRedDot = false;

    domain.principles.forEach((principle) => {
      let principleHasRedDot = false;

      principle.standards.forEach((standard) => {
        let standardHasRedDot = false;

        standard.evaluations.forEach((evaluation) => {
          if (iqcNeedsAttention[evaluation.evaluationCode] === "Y") {
            standardHasRedDot = true;
          }
        });

        // 상위 레벨로 레드닷 상태 전파
        if (standardHasRedDot) {
          principleHasRedDot = true;
          standard.hasRedDot = true; // UI 렌더링용
        }
      });

      if (principleHasRedDot) {
        domainHasRedDot = true;
        principle.hasRedDot = true; // UI 렌더링용
      }
    });

    if (domainHasRedDot) {
      domain.hasRedDot = true; // UI 렌더링용
    }
  });
};


const prepareKeepFiles = () => {
  const keepFiles = {};

  // ✅ 일반 평가 항목 파일
  Object.keys(existingFiles).forEach((code) => {
    keepFiles[code] = existingFiles[code].map((file) => file.path);
  });

  // ✅ A 도메인 파일
  directEvaluations.value.forEach((evaluation) => {
    const code = evaluation.evaluationCode;
    keepFiles[code] = existingFiles[code]?.map((file) => file.path) || [];
  });

  console.log("최종 유지할 파일 목록:", keepFiles);
  return keepFiles;
};


const validateBeforeFinalSave = async () => {
  const emptyEvaluation = Object.keys(eqcComment).find(
    (evaluationCode) => !eqcComment[evaluationCode] || eqcComment[evaluationCode].trim() === ""
  );

  if (emptyEvaluation) {
    alert(`${emptyEvaluation} 코드의 개선 권고사항이 비어 있습니다. 입력 후 다시 시도해주세요.`);

    // 📌 🚀 스크롤 이동 전, 자동으로 모든 노드를 펼침
    await scrollToEvaluation(emptyEvaluation);
    return;
  }

  finalSaveData();
};

const scrollToEvaluation = async (evaluationCode) => {
  // 점(.)을 하이픈(-)으로 변경하여 유효한 ID로 변환
  const safeEvaluationCode = evaluationCode.replace(/\./g, "-");

  // 1️⃣ 📌 해당 평가 코드가 포함된 모든 부모 노드를 자동으로 펼침
  await expandAllParentNodes(evaluationCode);

  // 2️⃣ 📌 Vue의 DOM 업데이트를 기다린 후 스크롤 이동 실행
  await nextTick();

  // 3️⃣ 📌 해당 평가 코드로 스크롤 이동
  const element = document.querySelector(`#evaluation-${safeEvaluationCode}`);

  if (element) {
    element.scrollIntoView({ behavior: "smooth", block: "center" });
  } else {
    console.warn(`ID가 ${safeEvaluationCode}인 요소를 찾을 수 없습니다.`);
  }
};

// ✅ 🚀 **모든 상위 노드를 자동으로 펼치는 함수**
const expandAllParentNodes = async (evaluationCode) => {
  let expanded = false; // 최소 한 개의 노드가 펼쳐졌는지 확인

  for (const key in evaluationVisibility) {
    if (evaluationCode.startsWith(key)) {
      evaluationVisibility[key] = true;
      expanded = true;
    }
  }

  for (const key in subItemsVisibilityStandard) {
    if (evaluationCode.startsWith(key)) {
      subItemsVisibilityStandard[key] = true;
      expanded = true;
    }
  }

  for (const key in subItemsVisibility) {
    if (evaluationCode.startsWith(key)) {
      subItemsVisibility[key] = true;
      expanded = true;
    }
  }

  // **만약 한 개 이상의 노드를 펼쳤다면, Vue의 DOM 업데이트를 기다림**
  if (expanded) {
    await nextTick();
  }
};

const finalSaveData = async () => {
  isLoading.value = true; // 로딩 시작
  try {
    let paramMail = {
      organizationCode : orgCode.value
    }

    let rtnMail = await sendIQCMail(paramMail)
    if (rtnMail?.result == 'ok') {
      alert(orgName.value+"의 IQC에게 이메일을 보냈습니다. ")
      window.location.reload();
    }else{
      alert("이메일 전송에 실패했습니다.")
    }

  } catch (error) {
    console.error("저장 중 오류 발생:", error);
  } finally {
    isLoading.value = false; // 로딩 종료
  }
}


// Save Data 로직 수정
const saveData = async (check) => { 
  isLoading.value = true; // 로딩 시작
  try {
    const result = [];
    const formData = new FormData();

    let isFileLimitExceeded = false;

    // ✅ 일반 평가 항목 처리 (transformedDomains)
    transformedDomains.value.forEach((domain) => {
      domain.principles.forEach((principle) => {
        principle.standards.forEach((standard) => {
          standard.evaluations.forEach((evaluation) => {
            const code = evaluation.evaluationCode;
           
            const aScore_approach = Number(String(scoreATensApproach[code]) + String(scoreAUnitApproach[code])) || 0;
            const bScore_approach = Number(String(scoreBTensApproach[code]) + String(scoreBUnitApproach[code])) || 0; 
            const entry = {
              memberCode: checkUserId.value.memberCode,
              organizationCode: orgCode.value,
              evaluationCode: code,
              evaluationScore: Number(scoreAApproach[code]) + Number(scoreADeployment[code]) + Number(scoreAMonitoring[code]) + Number(scoreAAction[code]),
              evaluationCurrent: evaluationContent[code] || null,
              evaluationImp: evaluationImprovements[code] || null,
              evaluationCmt: evaluationComment[code] || null,
              evaluationMonitoring: evaluationMonitoring[code] || null,
              evaluationAction: evaluationAction[code] || null,
              orgGiasYear : selectedYear.value,
              completedYn : 'N',
              eqcComment: eqcComment[code] || null,
              scoreAApproach : scoreAApproach[code]|| 0,
              // scoreATensApproach : scoreATensApproach[code] || 0,
              // scoreAUnitApproach: scoreAUnitApproach[code] || 0,

              // scoreBApproach: String(scoreBTensApproach[code]) + String(scoreBUnitApproach[code]),
              // scoreBTensApproach: scoreBTensApproach[code] || 0,
              // scoreBUnitApproach: scoreBUnitApproach[code] || 0,
              // scoreApproach: (aScore_approach + bScore_approach) / 2,

              // Deployment
              scoreADeployment : scoreADeployment[code]|| 0,

              // Monitoring
              scoreAMonitoring : scoreAMonitoring[code]|| 0,

              // Action
              scoreAAction : scoreAAction[code]|| 0,

              approachStr : approachStr[code]|| null,
              deploymentStr : deploymentStr[code]|| null,
              monitotingStr : monitotingStr[code]|| null,
              actionStr : actionStr[code]|| null,
              approachWeak : approachWeak[code]|| null,
              deploymentWeak : deploymentWeak[code]|| null,
              monitotingWeak : monitotingWeak[code]|| null,
              actionWeak : actionWeak[code]|| null,

            };
            result.push(entry);

            // 파일 개수 확인
            const existingFileCount = existingFiles[code]?.length || 0;
            const newFileCount = newFiles[code]?.length || 0;
            const totalFileCount = existingFileCount + newFileCount;

            if (totalFileCount > 7) {
              isFileLimitExceeded = true;
            }

            // 새로 추가된 파일
            if (newFiles[code]) {
              newFiles[code].forEach((file) => {
                formData.append(`files[${code}][]`, file);
              });
            }
            
          });
        });
      });
    });
    
    // ✅ 파일 제한 초과 시 경고 및 실행 중단
    if (isFileLimitExceeded) {
      alert("첨부파일은 평가 코드당 최대 7개까지만 가능합니다.");
      return;
    }

    // ✅ 유지할 파일
    const keepFiles = prepareKeepFiles();
    formData.append("keepFiles", JSON.stringify(keepFiles));

    formData.append("data", JSON.stringify(result));

    // ✅ 서버로 데이터 전송
    try {
      if (check === "insert") {
        if (confirm("저장 하시겠습니까?")) {
          const response = await insertGias(formData);
          if (response.result === "ok") {
            alert("저장에 성공했습니다.");
            window.location.reload();
          } else {
            alert("저장에 실패했습니다.");
          }
        }
      } 
      
      if(check === "update") {
        if (confirm("수정 하시겠습니까?")) {
          formData.append("checkString", "Admin");
          formData.append("memberCode", checkUserId.value.memberCode);
          formData.append("orgCode", orgCode.value);
          const response = await updateGiasByEQC(formData);
          if (response.result === "ok") {
            formData.append("organizationCode", orgCode.value);
            const rtn = await updateGiasFile(formData);
            if (rtn.result === "ok") {
              alert("수정에 성공했습니다.");
              window.location.reload();
            } else {
              alert("파일 수정에 실패했습니다.");
            }
          } else {
            alert("수정에 실패했습니다.");
          }
        }
      }

      if(check === "final") {
        if (confirm("평가완료 하시겠습니까? 평가완료 후 수정이 불가능합니다. ")) {
          formData.append("checkString", "Admin");
          formData.append("memberCode", checkUserId.value.memberCode);
          formData.append("orgCode", checkUserId.value.organizationCode);
          const response = await updateGiasByEQC(formData);
          if (response.result === "ok") {
            formData.append("organizationCode", checkUserId.value.organizationCode);
            const rtn = await updateGiasFile(formData);
            if (rtn.result === "ok") {

            } else {
              alert("파일 수정에 실패했습니다.");
            }
          } else {
            alert("수정에 실패했습니다.");
          }
        }
      }


    } catch (error) {
      console.error("저장 중 오류 발생:", error);
      alert("오류가 발생했습니다.");
    }
  } catch (error) {
    console.error("저장 중 오류 발생:", error);
  } finally {
    isLoading.value = false; // 로딩 종료
  }
};

//엑셀데이터 저장장
const saveExcelData = async (check) => { 
  isLoading.value = true; // 로딩 시작
  try {
    const result = [];
    const formData = new FormData();

    let isFileLimitExceeded = false;

    // ✅ 일반 평가 항목 처리 (transformedDomains)
    transformedDomains.value.forEach((domain) => {
      domain.principles.forEach((principle) => {
        principle.standards.forEach((standard) => {
          standard.evaluations.forEach((evaluation) => {
            const code = evaluation.evaluationCode;
           
            const entry = {
              memberCode: checkUserId.value.memberCode,
              organizationCode: orgCode.value,
              evaluationCode: code,
              evaluationScore: evaluationScore[code] || null,
              evaluationCurrent: evaluationContent[code] || null,
              evaluationImp: evaluationImprovements[code] || null,
              evaluationCmt: evaluationComment[code] || null,
              orgGiasYear : selectedYear.value,
              completedYn : 'N',
              eqcComment: eqcComment[code] || null,
              checkUser : 'admin'
            };
            result.push(entry);

            // 파일 개수 확인
            const existingFileCount = existingFiles[code]?.length || 0;
            const newFileCount = newFiles[code]?.length || 0;
            const totalFileCount = existingFileCount + newFileCount;

            if (totalFileCount > 7) {
              isFileLimitExceeded = true;
            }

            // 새로 추가된 파일
            if (newFiles[code]) {
              newFiles[code].forEach((file) => {
                formData.append(`files[${code}][]`, file);
              });
            }
            
          });
        });
      });
    });

    if(checkUserId.value.privilege !== 'user'){
      // ✅ A 도메인 평가 항목 처리 (directEvaluations)
      directEvaluations.value.forEach((evaluation) => {
        const code = evaluation.evaluationCode;

        const entry = {
          memberCode: checkUserId.value.memberCode,
          organizationCode: orgCode.value,
          evaluationCode: code,
          evaluationScore: evaluation.score_A || null,
          evaluationCurrent: evaluation.content_A || null,
          evaluationImp: evaluation.improvement_A || null,
          evaluationCmt: evaluation.comment_A || null,
          orgGiasYear : selectedYear.value,
          completedYn : 'N',
          eqcComment: evaluation.eqcComment_A || null,
          checkUser : 'admin'
        };

        result.push(entry);

        // 파일 개수 확인
        const existingFileCount = existingFiles[code]?.length || 0;
        const newFileCount = evaluation.files?.length || 0;
        const totalFileCount = existingFileCount + newFileCount;

        if (totalFileCount > 7) {
          isFileLimitExceeded = true;
        }

        // 새로 추가된 파일
        if (evaluation.files) {
          evaluation.files.forEach((file) => {
            formData.append(`files[${code}][]`, file);
          });
        }
      });

    }
    
    // ✅ 파일 제한 초과 시 경고 및 실행 중단
    if (isFileLimitExceeded) {
      alert("첨부파일은 평가 코드당 최대 7개까지만 가능합니다.");
      return;
    }

    // ✅ 유지할 파일
    const keepFiles = prepareKeepFiles();
    formData.append("keepFiles", JSON.stringify(keepFiles));

    formData.append("data", JSON.stringify(result));

    // ✅ 서버로 데이터 전송
    try {
      if (confirm("저장 하시겠습니까?")) {
        let param = {
          organizationCode: orgCode.value,
          orgGiasYear : selectedYear.value
        };

        const responseCeheck = await checkSavedGIAS(param);

        if (responseCeheck.result === "ok") { // 데이터가 
          const response = await insertGias(formData);
          if (response.result === "ok") {
            alert("저장에 성공했습니다.");
            window.location.reload();
          } else {
            alert("저장에 실패했습니다.");
          }
        } else {
          const response = await updateGiasByEQC(formData);
          if (response.result === "ok") {
            alert("엑셀 데이터 수정에 성공했습니다.");
            window.location.reload();
          } else {
            alert("엑셀 데이터 수정에 실패했습니다.");
          }
        }
      }
      
    } catch (error) {
      console.error("저장 중 오류 발생:", error);
      alert("오류가 발생했습니다.");
    }
  } catch (error) {
    console.error("저장 중 오류 발생:", error);
  } finally {
    isLoading.value = false; // 로딩 종료
  }
};



// 트리 구조 변환 함수
const transformToTreeStructure = (data) => {
  const groupedData = {};

  data.forEach((item) => {
    if (!groupedData[item.domainCode]) {
      groupedData[item.domainCode] = {
        domainCode: item.domainCode,
        domainName: item.domainName,
        principles: {},
      };
    }
    const domain = groupedData[item.domainCode];

    if (!domain.principles[item.principleCode]) {
      domain.principles[item.principleCode] = {
        principleCode: item.principleCode,
        principleName: item.principleName,
        principleContent:item.principleContent,
        standards: {},
      };
    }
    const principle = domain.principles[item.principleCode];

    if (!principle.standards[item.standardCode]) {
      principle.standards[item.standardCode] = {
        standardCode: item.standardCode,
        standardName: item.standardName,
        standardContent: item.standardContent,
        evaluations: [],
      };
    }
    const standard = principle.standards[item.standardCode];

    standard.evaluations.push({
      evaluationCode: item.evaluationCode,
      evaluationName: item.evaluationName,
      evaluationApproachContent : item.evaluationApproachContent,
      evaluationDeploymentContent : item.evaluationDeploymentContent,
      evaluationMonitoringContent : item.evaluationMonitoringContent,
      evaluationActionContent : item.evaluationActionContent
    });
  });

  return Object.values(groupedData).map((domain) => ({
    ...domain,
    principles: Object.values(domain.principles).map((principle) => ({
      ...principle,
      standards: Object.values(principle.standards),
    })),
  }));
};


// 트리 변환된 데이터
const transformedDomains = computed(() => transformToTreeStructure(domainList.value));

// 토글 상태
const subItemsVisibility = reactive({});
const subItemsVisibilityStandard = reactive({});
const evaluationVisibility = reactive({});

// 평가 데이터 상태
const evaluationContent = reactive({});
const evaluationContent2 = reactive({});
const evaluationContent3 = reactive({});
const evaluationContent4 = reactive({});
const evaluationContent5 = reactive({});
const evaluationContent6 = reactive({});
//현황 수정 시간
const evaluationCurrentTime = reactive({});
const evaluationCurrent2Time = reactive({});
const evaluationCurrent3Time = reactive({});
const evaluationCurrent4Time = reactive({});
const evaluationCurrent5Time = reactive({});


//개선사항 데이터 상세
const evaluationImprovements = reactive({});
const evaluationImprovements2 = reactive({});
const evaluationImprovements3 = reactive({});
const evaluationImprovements4 = reactive({});
const evaluationImprovements5 = reactive({});
const evaluationImprovements6 = reactive({});

//개선사항 수정 로그 시간
const evaluationImpTime = reactive({});
const evaluationImp2Time = reactive({});
const evaluationImp3Time = reactive({});
const evaluationImp4Time = reactive({});
const evaluationImp5Time = reactive({});

//권고사항 데이터 상세
const evaluationComment = reactive({});
const evaluationComment2 = reactive({});
const evaluationComment3 = reactive({});
const evaluationComment4 = reactive({});
const evaluationComment5 = reactive({});
const evaluationComment6 = reactive({});

//권고사항 수정 로그시간
const evaluationCmtTime = reactive({});
const evaluationCmtTime2 = reactive({});
const evaluationCmtTime3 = reactive({});
const evaluationCmtTime4 = reactive({});
const evaluationCmtTime5 = reactive({});

const evaluationScore = reactive({});
const evaluationFiles = reactive({});
const completedYn = reactive({});
const iqcCompletedYn = reactive({});
const iqaNeedsAttention = reactive({});
const iqcNeedsAttention = reactive({});

// 모니터링 데이터 상세
const evaluationMonitoring = reactive({});
const evaluationMonitoring2 = reactive({});
const evaluationMonitoring3 = reactive({});
const evaluationMonitoring4 = reactive({});
const evaluationMonitoring5 = reactive({});
const evaluationMonitoring6 = reactive({});

//모니터링 수정 로그 시간
const evaluationMonitoringTime = reactive({});
const evaluationMonitoring2Time = reactive({});
const evaluationMonitoring3Time = reactive({});
const evaluationMonitoring4Time = reactive({});
const evaluationMonitoring5Time = reactive({});

// 액션 데이터 상세
const evaluationAction = reactive({});
const evaluationAction2 = reactive({});
const evaluationAction3 = reactive({});
const evaluationAction4 = reactive({});
const evaluationAction5 = reactive({});
const evaluationAction6 = reactive({});

//액션 수정 로그 시간
const evaluationActionTime = reactive({});
const evaluationAction2Time = reactive({});
const evaluationAction3Time = reactive({});
const evaluationAction4Time = reactive({});
const evaluationAction5Time = reactive({});


const scoreAApproach = reactive({});
const scoreATensApproach = reactive({});
const scoreAUnitApproach = reactive({});

const scoreBApproach = reactive({});
const scoreBTensApproach = reactive({});
const scoreBUnitApproach = reactive({});

const scoreApproach = reactive({});
////////////////////////////////////////////////////////////////



const scoreADeployment = reactive({});
const scoreATensDeployment = reactive({});
const scoreAUnitsDeployment = reactive({});

const scoreBDeployment = reactive({});
const scoreBTensDeployment = reactive({});
const scoreBUnitsDeployment = reactive({});

const scoreDeployment = reactive({});


const scoreAMonitoring = reactive({});
const scoreATensMonitoring = reactive({});
const scoreAUnitsMonitoring = reactive({});
const scoreBMonitoring = reactive({});
const scoreBTensMonitoring = reactive({});
const scoreBUnitsMonitoring = reactive({});
const scoreMonitoring = reactive({});

const scoreAAction = reactive({});
const scoreATensAction = reactive({});
const scoreAUnitsAction = reactive({});
const scoreBAction = reactive({});
const scoreBTensAction = reactive({});
const scoreBUnitsAction = reactive({});
const scoreAction = reactive({});

const approachStr = reactive({});
const deploymentStr = reactive({});
const monitotingStr = reactive({});
const actionStr = reactive({});

const approachWeak = reactive({});
const deploymentWeak = reactive({});
const monitotingWeak = reactive({});
const actionWeak = reactive({});

const eqcComment = reactive({}); // EQC가 작성한 피드백
//파일 관리 상태
const existingFiles = reactive({}); // 존재하는 파일
const newFiles = reactive({}); // 새로운 파일
const deletedFiles = reactive({}); // 삭제할 파일

// 모든 평가 항목의 수와 iqcCompletedYn === "Y"인 항목 수를 계산
const giasCount = computed(() => Object.keys(iqcCompletedYn).length);
const iqcCompletedYnCount = computed(() =>
  Object.values(iqcCompletedYn).filter((value) => value === "Y").length
);

// 제출 버튼 비활성화 조건 계산
const isSubmitDisabled = computed(() => giasCount.value === iqcCompletedYnCount.value);

// 도메인 토글
const toggleSubItem = (domainCode) => {
  subItemsVisibility[domainCode] = !subItemsVisibility[domainCode];
};

// 프린서펄 토글
const toggleSubItemStandard = (domainCode, principleCode) => {
  const key = `${domainCode}-${principleCode}`;
  subItemsVisibilityStandard[key] = !subItemsVisibilityStandard[key];
};

// 스탠다드 토글
const toggleSubItemEvaluation = (domainCode, principleCode, standardCode) => {
  const key = `${domainCode}-${principleCode}-${standardCode}`;
  evaluationVisibility[key] = !evaluationVisibility[key];
};

const loadYearData = async () => {
  console.log(`📅 선택된 연도: ${selectedYear.value}`);
  alert(`${selectedYear.value}년 데이터를 불러옵니다.`);
  // 여기에 API 호출 또는 데이터 로직 추가
  let param = {
    organizationCode: orgCode.value,
    orgGiasYear : selectedYear.value
  };
  
  await store.dispatch("grid/fetchSelectPreviousYear", param);

  if (Array.isArray(orgEvlList.value)) {
    orgEvlList.value.forEach((savedEvl) => {
      const code = savedEvl.evaluationCode;
      if (code) {
        // ✅ 기존 transformedDomains 매핑
         //현황 내용
        evaluationContent[code] = savedEvl.evaluationCurrent || "";
        evaluationContent2[code] = savedEvl.evaluationCurrent2 || "";
        evaluationContent3[code] = savedEvl.evaluationCurrent3 || "";
        evaluationContent4[code] = savedEvl.evaluationCurrent4 || "";
        evaluationContent5[code] = savedEvl.evaluationCurrent5 || "";
        evaluationContent6[code] = savedEvl.evaluationCurrent6 || "";

        //현황 수정 시간
        evaluationCurrentTime[code] = savedEvl.evaluationCurrentTime || "";
        evaluationCurrent2Time[code] = savedEvl.evaluationCurrent2Time || "";
        evaluationCurrent3Time[code] = savedEvl.evaluationCurrent3Time || ""; 
        evaluationCurrent4Time[code] = savedEvl.evaluationCurrent4Time || "";
        evaluationCurrent5Time[code] = savedEvl.evaluationCurrent5Time || "";

        //개선사항 내용
        evaluationImprovements[code] = savedEvl.evaluationImp || "";
        evaluationImprovements2[code] = savedEvl.evaluationImp2 || "";
        evaluationImprovements3[code] = savedEvl.evaluationImp3 || "";
        evaluationImprovements4[code] = savedEvl.evaluationImp4 || "";
        evaluationImprovements5[code] = savedEvl.evaluationImp5 || "";
        evaluationImprovements6[code] = savedEvl.evaluationImp6 || "";

        // 권고사항 내용용
        evaluationComment[code] = savedEvl.evaluationCmt || "";
        evaluationComment2[code] = savedEvl.evaluationCmt2 || "";
        evaluationComment3[code] = savedEvl.evaluationCmt3 || "";
        evaluationComment4[code] = savedEvl.evaluationCmt4 || "";
        evaluationComment5[code] = savedEvl.evaluationCmt5 || "";
        evaluationComment6[code] = savedEvl.evaluationCmt6 || "";

        //권고사항 수정 시간
        evaluationCmtTime[code] = savedEvl.evaluationCmtTime || "";
        evaluationCmtTime2[code] = savedEvl.evaluationCmt2Time || "";
        evaluationCmtTime3[code] = savedEvl.evaluationCmt3Time || "";
        evaluationCmtTime4[code] = savedEvl.evaluationCmt4Time || "";
        evaluationCmtTime5[code] = savedEvl.evaluationCmt5Time || ""

        //개선사항 수정 시간
        evaluationImpTime[code] = savedEvl.evaluationImpTime || "";
        evaluationImp2Time[code] = savedEvl.evaluationImp2Time || "";
        evaluationImp3Time[code] = savedEvl.evaluationImp3Time || "";
        evaluationImp4Time[code] = savedEvl.evaluationImp4Time || "";
        evaluationImp5Time[code] = savedEvl.evaluationImp5Time || "";

        evaluationScore[code] = savedEvl.evaluationScore !== null ? savedEvl.evaluationScore : 0; // 기본값 0
        completedYn[code] = savedEvl.completedYn || "";
        iqcCompletedYn[code] = savedEvl.iqcCompletedYn || "";
        iqaNeedsAttention[code] = savedEvl.iqaNeedsAttention || "";
        iqcNeedsAttention[code] = savedEvl.iqcNeedsAttention || "";
        eqcComment[code] = savedEvl.eqcComment || "";

        // ✅ 파일 매핑
        const filePaths = [
          savedEvl.evaluationFile1,
          savedEvl.evaluationFile2,
          savedEvl.evaluationFile3,
          savedEvl.evaluationFile4,
          savedEvl.evaluationFile5,
          savedEvl.evaluationFile6,
          savedEvl.evaluationFile7,
        ].filter(Boolean);

        existingFiles[code] = filePaths.map((path) => ({
          name: path.split("/").pop(),
          path: path,
        }));

        evaluationFiles[code] = [...existingFiles[code]];

        // ✅ A 도메인(directEvaluations) 매핑
        const directEval = directEvaluations.value.find(
          (evalItem) => evalItem.evaluationCode === code
        );

        if (directEval) {
          directEval.content_A = savedEvl.evaluationCurrent || "";
          directEval.improvement_A = savedEvl.evaluationImp || "";
          directEval.comment_A = savedEvl.evaluationCmt || "";
          directEval.score_A = savedEvl.evaluationScore || 0;
          directEval.completedYn_A = savedEvl.completedYn || null;
          directEval.iqcCompletedYn_A = savedEvl.iqcCompletedYn || null;
          directEval.eqcComment_A = savedEvl.eqcComment || null;

          // 파일 매핑
          directEval.files = filePaths.map((path) => ({
            name: path.split("/").pop(),
            path: path,
          }));
        }
      }
    });
  }

  // 기본값 0으로 매핑되지 않은 항목 처리
  transformedDomains.value.forEach((domain) => {
    domain.principles.forEach((principle) => {
      principle.standards.forEach((standard) => {
        standard.evaluations.forEach((evaluation) => {
          const code = evaluation.evaluationCode;
          if (!evaluationScore[code]) {
            evaluationScore[code] = 0; // 디폴트 값 0
          }
        });
      });
    });
  });

  propagateRedDot(transformedDomains.value);
};

// 모든 내부통제체계 진단 항목을 가져오기기
const getGridData = async () => {

  await store.dispatch("grid/fetchGiasAllData");
};

// 파라미터로 넣은 기업의 평가원들이 작성한 모든 데이터를 가져옴
const getEvlData = async () => {
  let param = {
    organizationCode: orgCode.value,
    orgGiasYear : '2025'
  };
  await store.dispatch("grid/fetchAdminEvlOrg", param);

  if (Array.isArray(orgEvlList.value)) {
    orgEvlList.value.forEach((savedEvl) => {
      const code = savedEvl.evaluationCode;
      if (code) {
        // ✅ 기존 transformedDomains 매핑
         //현황 내용
        evaluationContent[code] = savedEvl.evaluationCurrent || "";
        evaluationContent2[code] = savedEvl.evaluationCurrent2 || "";
        evaluationContent3[code] = savedEvl.evaluationCurrent3 || "";
        evaluationContent4[code] = savedEvl.evaluationCurrent4 || "";
        evaluationContent5[code] = savedEvl.evaluationCurrent5 || "";
        evaluationContent6[code] = savedEvl.evaluationCurrent6 || "";

        //현황 수정 시간
        evaluationCurrentTime[code] = savedEvl.evaluationCurrentTime || "";
        evaluationCurrent2Time[code] = savedEvl.evaluationCurrent2Time || "";
        evaluationCurrent3Time[code] = savedEvl.evaluationCurrent3Time || ""; 
        evaluationCurrent4Time[code] = savedEvl.evaluationCurrent4Time || "";
        evaluationCurrent5Time[code] = savedEvl.evaluationCurrent5Time || "";

        //개선사항 내용
        evaluationImprovements[code] = savedEvl.evaluationImp || "";
        evaluationImprovements2[code] = savedEvl.evaluationImp2 || "";
        evaluationImprovements3[code] = savedEvl.evaluationImp3 || "";
        evaluationImprovements4[code] = savedEvl.evaluationImp4 || "";
        evaluationImprovements5[code] = savedEvl.evaluationImp5 || "";
        evaluationImprovements6[code] = savedEvl.evaluationImp6 || "";

        // 권고사항 내용용
        evaluationComment[code] = savedEvl.evaluationCmt || "";
        evaluationComment2[code] = savedEvl.evaluationCmt2 || "";
        evaluationComment3[code] = savedEvl.evaluationCmt3 || "";
        evaluationComment4[code] = savedEvl.evaluationCmt4 || "";
        evaluationComment5[code] = savedEvl.evaluationCmt5 || "";
        evaluationComment6[code] = savedEvl.evaluationCmt6 || "";

        //권고사항 수정 시간
        evaluationCmtTime[code] = savedEvl.evaluationCmtTime || "";
        evaluationCmtTime2[code] = savedEvl.evaluationCmt2Time || "";
        evaluationCmtTime3[code] = savedEvl.evaluationCmt3Time || "";
        evaluationCmtTime4[code] = savedEvl.evaluationCmt4Time || "";
        evaluationCmtTime5[code] = savedEvl.evaluationCmt5Time || ""

        //개선사항 수정 시간
        evaluationImpTime[code] = savedEvl.evaluationImpTime || "";
        evaluationImp2Time[code] = savedEvl.evaluationImp2Time || "";
        evaluationImp3Time[code] = savedEvl.evaluationImp3Time || "";
        evaluationImp4Time[code] = savedEvl.evaluationImp4Time || "";
        evaluationImp5Time[code] = savedEvl.evaluationImp5Time || "";

        evaluationScore[code] = savedEvl.evaluationScore !== null ? savedEvl.evaluationScore : 0; // 기본값 0
        completedYn[code] = savedEvl.completedYn || "";
        iqcCompletedYn[code] = savedEvl.iqcCompletedYn || "";
        iqaNeedsAttention[code] = savedEvl.iqaNeedsAttention || "";
        iqcNeedsAttention[code] = savedEvl.iqcNeedsAttention || "";
        eqcComment[code] = savedEvl.eqcComment || "";


         // 모니터링 내용
        evaluationMonitoring[code] =  savedEvl.evaluationMonitoring || "";
        evaluationMonitoring2[code] = savedEvl.evaluationMonitoring2 || "";
        evaluationMonitoring3[code] = savedEvl.evaluationMonitoring3 || "";
        evaluationMonitoring4[code] = savedEvl.evaluationMonitoring4 || "";
        evaluationMonitoring5[code] = savedEvl.evaluationMonitoring5 || "";
        evaluationMonitoring6[code] = savedEvl.evaluationMonitoring6 || "";

        // 모니터링 수정시간
        evaluationMonitoringTime[code] =  savedEvl.evaluationMonitoringTime || "";
        evaluationMonitoring2Time[code] = savedEvl.evaluationMonitoring2Time || "";
        evaluationMonitoring3Time[code] = savedEvl.evaluationMonitoring3Time || "";
        evaluationMonitoring4Time[code] = savedEvl.evaluationMonitoring4Time || "";
        evaluationMonitoring5Time[code] = savedEvl.evaluationMonitoring5Time || ""


        // 액션 내용
        evaluationAction[code] =  savedEvl.evaluationAction || "";
        evaluationAction2[code] = savedEvl.evaluationAction2 || "";
        evaluationAction3[code] = savedEvl.evaluationAction3 || "";
        evaluationAction4[code] = savedEvl.evaluationAction4 || "";
        evaluationAction5[code] = savedEvl.evaluationAction5 || "";
        evaluationAction6[code] = savedEvl.evaluationAction6 || "";

        // 액션 수정시간
        evaluationActionTime[code] =  savedEvl.evaluationActionTime || "";
        evaluationAction2Time[code] = savedEvl.evaluationAction2Time || "";
        evaluationAction3Time[code] = savedEvl.evaluationAction3Time || "";
        evaluationAction4Time[code] = savedEvl.evaluationAction4Time || "";
        evaluationAction5Time[code] = savedEvl.evaluationAction5Time || ""

        //평가점수
        evaluationScore[code] = savedEvl.evaluationScore !== null ? savedEvl.evaluationScore : 0; // 기본값 0
        scoreAApproach[code] = savedEvl.scoreAApproach !== null ? savedEvl.scoreAApproach : 0;
        scoreATensApproach[code] = savedEvl.scoreATensApproach !== null ? savedEvl.scoreATensApproach : 0;
        scoreAUnitApproach[code] = savedEvl.scoreAUnitApproach !== null ? savedEvl.scoreAUnitApproach : 0;
        scoreBApproach[code] = savedEvl.scoreBApproach !== null ? savedEvl.scoreBApproach : 0;
        scoreBTensApproach[code] = savedEvl.scoreBTensApproach !== null ? savedEvl.scoreBTensApproach : 0;
        scoreBUnitApproach[code] = savedEvl.scoreBUnitApproach !== null ? savedEvl.scoreBUnitApproach : 0;
        scoreApproach[code] = savedEvl.scoreApproach !== null ? savedEvl.scoreApproach : 0;

        scoreADeployment[code] = savedEvl.scoreADeployment !== null ? savedEvl.scoreADeployment : 0;
        scoreATensDeployment[code] = savedEvl.scoreATensDeployment !== null ? savedEvl.scoreATensDeployment : 0;
        scoreAUnitsDeployment[code] = savedEvl.scoreAUnitsDeployment !== null ? savedEvl.scoreAUnitsDeployment : 0;
        scoreBDeployment[code] = savedEvl.scoreBDeployment !== null ? savedEvl.scoreBDeployment : 0;
        scoreBTensDeployment[code] = savedEvl.scoreBTensDeployment !== null ? savedEvl.scoreBTensDeployment : 0;
        scoreBUnitsDeployment[code] = savedEvl.scoreBUnitsDeployment !== null ? savedEvl.scoreBUnitsDeployment : 0;
        scoreDeployment[code] = savedEvl.scoreDeployment !== null ? savedEvl.scoreDeployment : 0;

        scoreAMonitoring[code] = savedEvl.scoreAMonitoring !== null ? savedEvl.scoreAMonitoring : 0;
        scoreATensMonitoring[code] = savedEvl.scoreATensMonitoring !== null ? savedEvl.scoreATensMonitoring : 0;
        scoreAUnitsMonitoring[code] = savedEvl.scoreAUnitsMonitoring !== null ? savedEvl.scoreAUnitsMonitoring : 0;
        scoreBMonitoring[code] = savedEvl.scoreBMonitoring !== null ? savedEvl.scoreBMonitoring : 0;
        scoreBTensMonitoring[code] = savedEvl.scoreBTensMonitoring !== null ? savedEvl.scoreBTensMonitoring : 0;
        scoreBUnitsMonitoring[code] = savedEvl.scoreBUnitsMonitoring !== null ? savedEvl.scoreBUnitsMonitoring : 0;
        scoreMonitoring[code] = savedEvl.scoreMonitoring !== null ? savedEvl.scoreMonitoring : 0;

        scoreAAction[code] = savedEvl.scoreAAction !== null ? savedEvl.scoreAAction : 0;
        scoreATensAction[code] = savedEvl.scoreATensAction !== null ? savedEvl.scoreATensAction : 0;
        scoreAUnitsAction[code] = savedEvl.scoreAUnitsAction !== null ? savedEvl.scoreAUnitsAction : 0;
        scoreBAction[code] = savedEvl.scoreBAction !== null ? savedEvl.scoreBAction : 0;
        scoreBTensAction[code] = savedEvl.scoreBTensAction !== null ? savedEvl.scoreBTensAction : 0;
        scoreBUnitsAction[code] = savedEvl.scoreBUnitsAction !== null ? savedEvl.scoreBUnitsAction : 0;
        scoreAction[code] = savedEvl.scoreAction !== null ? savedEvl.scoreAction : 0;

        approachStr[code] = savedEvl.approachStr || "";
        deploymentStr[code] = savedEvl.deploymentStr || "";
        monitotingStr[code] = savedEvl.monitotingStr|| "";
        actionStr[code] = savedEvl.actionStr|| "";
        approachWeak[code] = savedEvl.approachWeak || "";
        deploymentWeak[code] = savedEvl.deploymentWeak || "";
        monitotingWeak[code] = savedEvl.monitotingWeak || "";
        actionWeak[code] = savedEvl.actionWeak || "";
        
        // ✅ 파일 매핑
        const filePaths = [
          savedEvl.evaluationFile1,
          savedEvl.evaluationFile2,
          savedEvl.evaluationFile3,
          savedEvl.evaluationFile4,
          savedEvl.evaluationFile5,
          savedEvl.evaluationFile6,
          savedEvl.evaluationFile7,
        ].filter(Boolean);

        existingFiles[code] = filePaths.map((path) => ({
          name: path.split("/").pop(),
          path: path,
        }));

        evaluationFiles[code] = [...existingFiles[code]];

        // ✅ A 도메인(directEvaluations) 매핑
        const directEval = directEvaluations.value.find(
          (evalItem) => evalItem.evaluationCode === code
        );

        if (directEval) {
          directEval.content_A = savedEvl.evaluationCurrent || "";
          directEval.improvement_A = savedEvl.evaluationImp || "";
          directEval.comment_A = savedEvl.evaluationCmt || "";
          directEval.score_A = savedEvl.evaluationScore || 0;
          directEval.completedYn_A = savedEvl.completedYn || null;
          directEval.iqcCompletedYn_A = savedEvl.iqcCompletedYn || null;
          directEval.eqcComment_A = savedEvl.eqcComment || null;

          // 파일 매핑
          directEval.files = filePaths.map((path) => ({
            name: path.split("/").pop(),
            path: path,
          }));
        }
      }
    });
  }

  // 기본값 0으로 매핑되지 않은 항목 처리
  transformedDomains.value.forEach((domain) => {
    domain.principles.forEach((principle) => {
      principle.standards.forEach((standard) => {
        standard.evaluations.forEach((evaluation) => {
          const code = evaluation.evaluationCode;
          if (!evaluationScore[code]) {
            evaluationScore[code] = 0; // 디폴트 값 0
          }
        });
      });
    });
  });

  propagateRedDot(transformedDomains.value);
};

let orgName = ref('')
let orgCode = ref('')
let orgMail = ref('')

onMounted(async () => {
  //console.log(checkUserId.value.subRole)
  orgName.value = route.query?.organizationName || ''; 
  orgCode.value = route.query?.organizationCode || ''; 
  orgMail.value = route.query?.organizationMail || ''; 
  await getGridData();
  const gridDataAvailable = domainList.value && domainList.value.length > 0;

  await getEvlData();
  const evlDataAvailable = orgEvlList.value && orgEvlList.value.length > 0;

    // 버튼 표시 로직 설정
  if (!gridDataAvailable && !evlDataAvailable) {
      alert("저장할 항목 또는 수정할 항목이 없습니다. 관리자에게 문의해주세요");
      hasData.value = false; // 버튼 숨김
  } else if (gridDataAvailable && !evlDataAvailable) {
      hasData.value = "insert"; // "저장" 버튼
  } else if (gridDataAvailable && evlDataAvailable) {
      hasData.value = "update"; // "수정" 버튼
  } else {
      hasData.value = false; // 버튼 숨김
  }

  if (Array.isArray(orgEvlList.value)) {
    orgEvlList.value.forEach((savedEvl, index) => {
    //console.log(`[${index + 1}] 항목 데이터:`, savedEvl); // 각 항목의 전체 구조 출력

    const code = savedEvl.evaluationCode; // evaluationCode 확인
    if (code) {
        // 데이터 매핑
        evaluationContent[code] = savedEvl.evaluationCurrent || "";
        evaluationImprovements[code] = savedEvl.evaluationImp || "";
        evaluationComment[code] = savedEvl.evaluationCmt || "";
        evaluationScore[code] = savedEvl.evaluationScore || 0;
        completedYn[code] = savedEvl.completedYn || "";
    }
    });
  } 

     // ✅ A 도메인 데이터 초기화
  directEvaluations.value.forEach((evaluation) => {
    initialEvaluationContent[evaluation.evaluationCode] = evaluation.content_A;
    initialEvaluationImprovements[evaluation.evaluationCode] = evaluation.improvement_A;
    initialEvaluationComment[evaluation.evaluationCode] = evaluation.comment_A;
    initialEvaluationScore[evaluation.evaluationCode] = evaluation.score_A;
  });
  console.log("hasData 상태:", hasData.value); // 디버깅용
  window.addEventListener("scroll", handleScroll);

    // 초기 데이터를 깊은 복사로 저장
  initialEvaluationContent = JSON.parse(JSON.stringify(toRaw(evaluationContent)));
  initialEvaluationImprovements = JSON.parse(JSON.stringify(toRaw(evaluationImprovements)));
  initialEvaluationComment = JSON.parse(JSON.stringify(toRaw(evaluationComment)));
  initialEvaluationScore = JSON.parse(JSON.stringify(toRaw(evaluationScore)));
  initialEvaluationMonitoring = JSON.parse(JSON.stringify(toRaw(evaluationMonitoring)));
  initialEvaluationAction = JSON.parse(JSON.stringify(toRaw(evaluationAction)));
  initialEvaluationEQCComment = JSON.parse(JSON.stringify(toRaw(eqcComment)));

  transformedDomains.value.forEach((domain) => {
    const domainKey = domain.domainCode;
    subItemsVisibility[domainKey] = false;

    // Level 2: 프린서펄 상태 초기화
    domain.principles.forEach((principle) => {
      const principleKey = `${domainKey}-${principle.principleCode}`;
      subItemsVisibilityStandard[principleKey] = false;

      // Level 3: 스탠다드 상태 초기화
      principle.standards.forEach((standard) => {
        const standardKey = `${principleKey}-${standard.standardCode}`;
        evaluationVisibility[standardKey] = false;
      });
    });
  });

});

onUnmounted(() => {
	// 페이지 닫힐 때 해당 리스너 삭제
  const isContentChanged = JSON.stringify(toRaw(evaluationContent)) !== JSON.stringify(initialEvaluationContent);
  const isImprovementsChanged = JSON.stringify(toRaw(evaluationImprovements)) !== JSON.stringify(initialEvaluationImprovements);
  const isCommentChanged = JSON.stringify(toRaw(evaluationComment)) !== JSON.stringify(initialEvaluationComment);
  const isScoreChanged = JSON.stringify(toRaw(evaluationScore)) !== JSON.stringify(initialEvaluationScore);

  if (isContentChanged || isImprovementsChanged || isScoreChanged || isCommentChanged) {
      //saveData(hasData.value); // 데이터가 변경된 경우만 저장
  } 
}) 


const exportToJSON = () => {
  const jsonData = [];

  transformedDomains.value.forEach((domain) => {
    domain.principles.forEach((principle) => {
      principle.standards.forEach((standard) => {
        standard.evaluations.forEach((evaluation) => {
          const evaluationCode = evaluation.evaluationCode;
          const evaluationName = evaluation.evaluationName;

          // 첨부파일 리스트 가져오기
          const attachments = (evaluationFiles[evaluationCode] || []).map((file) => file.name);
          const attachmentList = attachments.length > 0 ? attachments.join(", ") : "첨부파일 없음";

          // JSON 객체 생성
          const entry = {
            도메인: domain.domainName,  // ✅ 도메인 추가
            프린서펄: principle.principleName, // ✅ 프린서펄 추가
            스탠다드: standard.standardName, // ✅ 스탠다드 추가
            평가코드: evaluationCode,
            평가항목명: evaluationName,
            현재평가내용: evaluationContent[evaluationCode] || null,
            개선내용: evaluationImprovements[evaluationCode] || null,
            관리자피드백: evaluationComment[evaluationCode] || null,
            첨부파일: attachmentList, // 첨부파일 리스트 추가
            평가점수: evaluationScore[evaluationCode] || null, // 평가점수를 가장 마지막에 배치
          };

          jsonData.push(entry);
        });
      });
    });
  });

  console.log("생성된 JSON 데이터:", jsonData);
  return jsonData;
};

// 평가 점수 매핑
const evaluationScores = computed(() => {
  const scores = {};
  orgEvlList.value.forEach((item) => {
    if (item.evaluationCode && item.evaluationScore) {
      scores[item.evaluationCode] = item.evaluationScore;
    }
  });
  return scores;
});

const downloadExcel = () => {
  const workbook = XLSX.utils.book_new();

  /** 📊 1. 통계 테이블 시트 생성 */
  const statsWorksheetData = [];
  const statsHeaders = [
    "(Level 1) Component",
    "(Level 2) Tactical Organizational Objectives",
    "(Level 3) Internal Control Objective",
    "(Level 4) Control Activity",
    "(Level 4) Code",
    "세부평가점수",
    "Approach",
    "Approach_점수",
    "Approach_강점",
    "Approach_약점",
    "Deployment",
    "Deployment_점수",
    "Deployment_강점",
    "Deployment_약점",
    "Monitoring Process",
    "Monitoring Process_점수",
    "Monitoring Process_강점",
    "Monitoring Process_약점",
    "Action",
    "Action_점수",
    "Action_강점",
    "Action_약점",
    "첨부파일",
    "개선권고사항"
  ];
  statsWorksheetData.push(statsHeaders);

  let currentRow = 1;

  transformedDomains.value.forEach(domain => {
    let isFirstDomainRow = true;

    domain.principles.forEach(principle => {
      let isFirstPrincipleRow = true;

      principle.standards.forEach(standard => {
        let isFirstStandardRow = true;

        standard.evaluations.forEach(evaluation => {

          // 첨부파일 리스트 가져오기
          const attachments = (evaluationFiles[evaluation.evaluationCode] || []).map((file) => file.name);
          const attachmentList = attachments.length > 0 ? attachments.join(", ") : "첨부파일 없음";
          
          const row = [
            isFirstDomainRow ? domain.domainName : "", // 도메인
            isFirstPrincipleRow ? principle.principleName : "", // 프린서펄 이름
            isFirstStandardRow ? standard.standardName : "", // 스탠다드 이름
            evaluation.evaluationName, // 게부평가사항
            evaluation.evaluationCode, // 세부평가 코드
            evaluationScores.value[evaluation.evaluationCode] || "평가중",

            evaluationContent[evaluation.evaluationCode] || null, // approach_평가내용
            scoreAApproach[evaluation.evaluationCode] || null, // approach_평가내용
            approachStr[evaluation.evaluationCode] || null, // approach_평가내용
            approachWeak[evaluation.evaluationCode] || null, // approach_평가내용

            
            evaluationImprovements[evaluation.evaluationCode] || null, //deployment 내용
            scoreADeployment[evaluation.evaluationCode] || null, //deployment 내용
            deploymentStr[evaluation.evaluationCode] || null, //deployment 내용
            deploymentWeak[evaluation.evaluationCode] || null, //deployment 내용

            
            evaluationMonitoring[evaluation.evaluationCode] || null, // Monitoring내용
            scoreAMonitoring[evaluation.evaluationCode] || null, // Monitoring내용
            monitotingStr[evaluation.evaluationCode] || null, // Monitoring내용
            monitotingWeak[evaluation.evaluationCode] || null, // Monitoring내용


            evaluationAction[evaluation.evaluationCode] || null, // Action내용
            scoreAAction[evaluation.evaluationCode] || null, // Action내용
            actionStr[evaluation.evaluationCode] || null, // Action내용
            actionWeak[evaluation.evaluationCode] || null, // Action내용


            attachmentList,
            eqcComment[evaluation.evaluationCode] || null,

          ];
          statsWorksheetData.push(row);
          currentRow++;

          isFirstDomainRow = false;
          isFirstPrincipleRow = false;
          isFirstStandardRow = false;
        });
      });
    });
  });

  const statsWorksheet = XLSX.utils.aoa_to_sheet(statsWorksheetData);
  XLSX.utils.book_append_sheet(workbook, statsWorksheet, "내부통제체계 진단 결과");

  /** 📊 2. 엑셀 파일 생성 및 다운로드 */
  XLSX.writeFile(workbook, `${orgName.value}_통계_전체_테이블.xlsx`);
};


const downloadAllFilesDirectly = async () => {
 try {
    const timestamp = new Date().toISOString().replace(/[-:.]/g, "").slice(0, 14); // YYYYMMDDHHMMSS
    const fileName = `${orgName.value}_내부통제체계 진단_파일_${timestamp}.zip`;

    // API 호출
    const response = await axios.get(`/gias/download-all-files`, {
      params: { organizationCode: orgCode.value },
      responseType: 'blob', // ZIP 파일 다운로드
    });

    if (response.status === 200) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      alert('ZIP 파일 다운로드가 완료되었습니다.');
    } else {
      console.error('ZIP 파일 다운로드 실패: 서버 응답이 올바르지 않습니다.', response);
      alert('ZIP 파일 다운로드에 실패했습니다.');
    }
  } catch (error) {
    console.error('ZIP 파일 다운로드 중 오류 발생:', error);
    alert('ZIP 파일 다운로드 중 오류가 발생했습니다. 관리자에게 문의하세요.');
  }
};


</script>


<style scoped>

/* ✅ Readonly 상태의 textarea 스타일 */
textarea[readonly] {
  background-color: #f0f0f0; /* 회색 배경 */
  color: #666; /* 텍스트 색상 */
  cursor: not-allowed; /* 마우스 커서 */
  border: 1px solid #ccc; /* 경계선 */
}


.year-dropdown {
  margin-left: 10px; /* 간격 추가 */
  padding: 2px 2px; /* 내부 패딩 */
  border: 1px solid #ccc; /* 테두리 스타일 */
  border-radius: 4px; /* 둥근 모서리 */
  font-size: 14px; /* 글꼴 크기 */
  cursor: pointer; /* 포인터 커서 */
  height: 25px;
  width: 50px;
  text-align: center;
}

.year-dropdown:focus {
  border-color: #0078d7; /* 포커스 시 테두리 색상 변경 */
  outline: none;
}

.load-button {
  margin-left: 10px; /* 간격 추가 */
  padding: 5px 15px; /* 내부 패딩 */
  background-color: #0078d7; /* 버튼 배경색 */
  color: white; /* 글자색 */
  border: none; /* 테두리 제거 */
  border-radius: 4px; /* 둥근 모서리 */
  cursor: pointer; /* 포인터 커서 */
  font-size: 14px; /* 글꼴 크기 */
}

.load-button:hover {
  background-color: #005bb5; /* 호버 시 색상 변경 */
}

/* 도움말 아이콘 */
.help-icon-wrapper {
  position: relative;
  display: inline-block;
  margin-right: 8px; /* 프린서펄이름과 간격 추가 */
  margin-left: 8px; /* 레드닷과 간격 추가 */
  vertical-align: middle; /* 아이콘이 텍스트와 중간 정렬되도록 */
}

.help-icon {
  width: 20px;
  height: 20px;
  background-color: #005bb5;
  color: #fff;
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}

/* 툴팁 스타일 */
.tooltip {
  font-size: 11px;
  font-weight: 500;
  line-height: 14px; /**줄간격 */
  visibility: hidden;
  background-color: #fff;
  color: #000;
  text-align: left;
  border-radius: 4px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  top: 120%; /* 부모의 중앙을 기준으로 위치 */
  left: 100%; /* 아이콘의 오른쪽에 위치 */
  transform: translate(20px, -50%); /* Y축 -50%로 중앙 정렬 */
  white-space: pre-wrap; /* 줄바꿈 허용 */
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  pointer-events: none;
  max-width: 700px; /* 최대 너비 제한 */
  width: max-content; /* 내용에 맞춰 너비 설정 */
}
/* 보이는 상태만 따로 */
.tooltip.visible {
  visibility: visible;
  opacity: 1;
  pointer-events: auto;
}
.tooltip-stand {
  font-size: 11px;
  font-weight: 500;
  line-height: 14px; /**줄간격 */
  visibility: hidden;
  background-color: #fff;
  color: #000;
  text-align: left;
  border-radius: 4px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  top: 50%; /* 부모의 중앙을 기준으로 위치 */
  left: 100%; /* 아이콘의 오른쪽에 위치 */
  transform: translate(20px, -50%); /* Y축 -50%로 중앙 정렬 */
  white-space: pre-wrap; /* 줄바꿈 허용 */
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  pointer-events: none;
  width: 300px;
}

.help-icon-wrapper:hover .tooltip {
  visibility: visible;
  opacity: 1;
}
.help-icon-wrapper:hover .tooltip-stand {
  visibility: visible;
  opacity: 1;
}

.red-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  background-color: red;
  border-radius: 50%;
  margin-left: 5px;
  vertical-align: middle;
}
.layout-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* 최소 높이를 뷰포트 높이로 설정 */
}
.footer {
  background-color: #FFFFFF; /* 배경색 지정 */
  text-align: center;
  padding: 10px 0;
  font-size: 14px;
}
.attach-list{
  margin-top: -10px;
  font-size: 14px;
  margin-left: 80px;
}
/* ✅ 저장 버튼 */
.save-button-container {
margin-top: 20px;
  text-align: right;
  display: flex;
  justify-content: flex-end;
  gap: 10px; /* 버튼 사이 간격 */
}

.save-button-container button {
  background-color: #0078d7;
  color: white;
  border-radius: 5px;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  font-size: 14px;
}

/* ✅ 최종 저장 버튼 스타일 (선택적 스타일 추가) */
.save-button-container button:last-child {
  background-color: #28a745; /* 초록색 버튼 */
}

/* 비활성화 상태 */
button:disabled {
  cursor: not-allowed; /* 금지 커서 */
  opacity: 0.2; /* 투명도 */
}

/* ✅ 트리 노드 스타일 */
.tree-node {
  border: 1px solid #ddd;
  border-radius: 5px;
  margin: 10px 0;
  padding: 14px;
  background-color: #f9fafc;
}

.level-1 {
  background-color: #CDE7FA;
  cursor: pointer;
}

.level-2 {
  background-color: #D7EFFB;
  margin-left: 20px;
}

.level-3 {
  background-color: #E3F2FD;
  margin-left: 20px;
}

.level-4 {
  background-color: #F1F8FE;
  cursor: default ;
  margin-left: 20px;
}

.node-title {
  font-weight: bold;
}
/* 한글 스타일 */
.node-title .korean-text {
  font-size: 16px;
}

/* 영어 스타일 */
.node-title .english-text {
  font-size: 10px;
}

/* ✅ 입력 그룹 */
.input-group {
  display: flex;
  align-items: flex-start; /* 텍스트박스와 수정 시간 정렬 */
  margin: 20px 0;
  gap: 10px; /* 입력창과 수정 시간 간격 추가 */
}

/* ✅ 텍스트 영역 래퍼 */
.textarea-wrapper {
  flex: 0 0 80%; /* 입력창을 80%로 설정 */
}

.textarea-wrapper textarea {
  height: 160px; /* 수정 시간 박스와 동일한 높이 설정 */
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  resize: vertical; /* 사용자가 세로로 크기 조정 가능 */
}

.input-group label {
  font-weight: normal;
  font-size: 14px;
  margin-bottom: 5px;
  display: block;
  white-space: nowrap; /* 텍스트가 줄바꿈되지 않도록 설정 */
}

.input-group textarea {
  width: 100%;
  height: 160px; /* 기존 높이에 +15px 추가 */
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  font-size: 14px;
  resize: vertical; /* 사용자가 세로로만 크기 조정 가능 */
}

/* ✅ 수정 시간 표시 박스 */

.timestamp-item {
  margin-bottom: 8px; /* 각 항목 간격 */
  color: #007bff; /* 파란색 텍스트 */
  text-decoration: underline; /* 밑줄 추가 */
  cursor : pointer;
}
/* 금지 커서와 스타일 변경 */
.timestamp-item.disabled {
  opacity: 0.5; /* 흐리게 표시 */
  cursor: not-allowed; /* 금지 커서 */
}
.timestamp-item:hover {
  background-color: #f0f0f0;
}

.textarea-wrapper.full-width {
  flex: 0 0 100%; /* textarea가 전체 너비를 차지 */
}


.timestamp-box {
  flex: 0 0 20%; /* 나머지 20% 할당 */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.timestamp-box label {
  font-weight: normal;
  font-size: 14px;
  margin-bottom: 5px;
}

.timestamp {
  padding: 8px;
  background-color: #f9f9f9; /* 수정 시간 표시 영역 배경 */
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  text-align: center;
  height: 160px; /* 자동 높이 조정 */
  display: flex;
  flex-direction: column; /* 세로 정렬 */
  align-items: flex-start; /* 왼쪽 정렬 */
  gap: 8px; /* 각 항목 간격 추가 */
  color: #666; /* 텍스트 색상 */
  overflow-y: auto;
}

.return-button-wrapper {
  margin-top: 10px;
}

.return-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
}

.return-button:hover {
  background-color: #0056b3;
}

/* ✅ 슬라이더 컨테이너 */
.custom-slider {
  position: relative;
  width: 300px;
  height: 30px;
  margin: 20px 0;
}


/* ✅ 슬라이더 트랙 (배경선) */
.custom-slider input[type="range"] {
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 8px;
  background: linear-gradient(to right, 
    #FF6F61 0%,   /* 왼쪽 초록색 */
    #FFD700 50%,  /* 중간 노란색 */
    #00FF00 100%  /* 오른쪽 빨간색 00FF00*/
  );
  border-radius: 10px;
  outline: none;
  cursor: pointer;
  z-index: 1;
  position: relative;
}

/* ✅ 슬라이더 핸들 (드래그 원 + 점수 표시) */
.slider-thumb {
  position: absolute;
  top: -4px; /* 핸들 위치 조정 */
  transform: translateX(70%);
  color: white;
  font-size: 14px;
  font-weight: bold;
  padding: 5px 17px; /* 내부 패딩 추가 */
  border-radius: 20px; /* 둥근 직사각형 */
  text-align: center;
  white-space: nowrap;
  box-shadow: 0 4px 8px rgba(168, 85, 247, 0.3);
  z-index: 2;
  pointer-events: none; /* 드래그 이벤트 방지 */
  line-height: 1.2;
  background: var(--slider-color, #A8E6CF); /* 기본 색상 (연한 초록) */
}

/* ✅ 점수 텍스트 포맷 */
.slider-thumb::after {
  margin-left: 2px;
  font-size: 12px;
  font-weight: normal;
}


/* ✅ 슬라이더 선택 영역 (선택된 부분) */
.slider-track {
  position: absolute;
  top: 50%;
  left: 0;
  height: 8px;
  border-radius: 10px;
  background: var(--slider-color, #A8E6CF); /* 선택된 부분 색상 */
  transform: translateY(-50%);
  z-index: 0;
  transition: width 0.2s ease-in-out;
}
</style>
